import {
  Domain, getEnumMeta, solidify, ModelType, ObjectType,
  PrimitiveProperty, ForeignKeyProperty, PrimaryKeyProperty,
  ModelCollectionNavigationProperty, ModelReferenceNavigationProperty,
  HiddenAreas, BehaviorFlags
} from 'coalesce-vue/lib/metadata'


const domain: Domain = { enums: {}, types: {}, services: {} }
export const AddonItemType = domain.enums.AddonItemType = {
  name: "AddonItemType" as const,
  displayName: "Addon Item Type",
  type: "enum",
  ...getEnumMeta<"FixedPerAddon"|"FixedPerTicket"|"PercentPerTicket">([
  {
    value: 0,
    strValue: "FixedPerAddon",
    displayName: "Fixed price per Addon Item",
    description: "Items must be refunded/exchanged individually.",
  },
  {
    value: 1,
    strValue: "FixedPerTicket",
    displayName: "Fixed price per Admission Ticket",
    description: "When admission tickets are refunded/exchanged, items of this type are too.",
  },
  {
    value: 2,
    strValue: "PercentPerTicket",
    displayName: "Percentage of Admission Tickets Price",
    description: "When admission tickets are refunded/exchanged, items of this type are too.",
  },
  ]),
}
export const AddonStatus = domain.enums.AddonStatus = {
  name: "AddonStatus" as const,
  displayName: "Addon Status",
  type: "enum",
  ...getEnumMeta<"Completed"|"Exchanged"|"Refunded">([
  {
    value: 0,
    strValue: "Completed",
    displayName: "Completed",
  },
  {
    value: 2,
    strValue: "Exchanged",
    displayName: "Exchanged",
  },
  {
    value: 3,
    strValue: "Refunded",
    displayName: "Refunded",
  },
  ]),
}
export const AlertSeverity = domain.enums.AlertSeverity = {
  name: "AlertSeverity" as const,
  displayName: "Alert Severity",
  type: "enum",
  ...getEnumMeta<"Info"|"Warning"|"Critical">([
  {
    value: 0,
    strValue: "Info",
    displayName: "Info",
    description: "Informational announcement.",
  },
  {
    value: 1,
    strValue: "Warning",
    displayName: "Warning",
    description: "Known issue or planned maintenance.",
  },
  {
    value: 2,
    strValue: "Critical",
    displayName: "Critical",
    description: "Urgent system outage or critical issue.",
  },
  ]),
}
export const BoardingLabel = domain.enums.BoardingLabel = {
  name: "BoardingLabel" as const,
  displayName: "Boarding Label",
  type: "enum",
  ...getEnumMeta<"Doors"|"Boarding"|"Arrive">([
  {
    value: 0,
    strValue: "Doors",
    displayName: "Doors open",
  },
  {
    value: 1,
    strValue: "Boarding",
    displayName: "Boarding begins",
  },
  {
    value: 2,
    strValue: "Arrive",
    displayName: "Arrive by",
  },
  ]),
}
export const CommissionType = domain.enums.CommissionType = {
  name: "CommissionType" as const,
  displayName: "Commission Type",
  type: "enum",
  ...getEnumMeta<"Percentage"|"Flat">([
  {
    value: 0,
    strValue: "Percentage",
    displayName: "Percentage",
  },
  {
    value: 1,
    strValue: "Flat",
    displayName: "Flat",
  },
  ]),
}
export const DiscountType = domain.enums.DiscountType = {
  name: "DiscountType" as const,
  displayName: "Discount Type",
  type: "enum",
  ...getEnumMeta<"PerPurchaseFlatRateDiscount"|"PerPurchasePercentageDiscount"|"PerTicketFlatRateDiscount"|"PerTicketPercentageDiscount">([
  {
    value: 0,
    strValue: "PerPurchaseFlatRateDiscount",
    displayName: "Per Purchase Flat Rate Discount",
  },
  {
    value: 1,
    strValue: "PerPurchasePercentageDiscount",
    displayName: "Per Purchase Percentage Discount",
  },
  {
    value: 2,
    strValue: "PerTicketFlatRateDiscount",
    displayName: "Per Ticket Flat Rate Discount",
  },
  {
    value: 3,
    strValue: "PerTicketPercentageDiscount",
    displayName: "Per Ticket Percentage Discount",
  },
  ]),
}
export const EmailType = domain.enums.EmailType = {
  name: "EmailType" as const,
  displayName: "Email Type",
  type: "enum",
  ...getEnumMeta<"ImmediatelyAfterPurchase"|"WithinOneDay"|"WithinTwoDays"|"ThreeHoursAfterTheEvent"|"OneHourAfterTheEvent"|"Confirmation"|"Cancellation"|"TicketRelease">([
  {
    value: 0,
    strValue: "ImmediatelyAfterPurchase",
    displayName: "Immediately After Purchase",
  },
  {
    value: 1,
    strValue: "WithinOneDay",
    displayName: "Within One Day",
  },
  {
    value: 4,
    strValue: "WithinTwoDays",
    displayName: "Within Two Days",
  },
  {
    value: 2,
    strValue: "ThreeHoursAfterTheEvent",
    displayName: "Three Hours After The Event",
  },
  {
    value: 3,
    strValue: "OneHourAfterTheEvent",
    displayName: "One Hour After The Event",
  },
  {
    value: 100,
    strValue: "Confirmation",
    displayName: "Confirmation",
  },
  {
    value: 101,
    strValue: "Cancellation",
    displayName: "Cancellation",
  },
  {
    value: 102,
    strValue: "TicketRelease",
    displayName: "Ticket Release",
  },
  ]),
}
export const EventSeriesStatus = domain.enums.EventSeriesStatus = {
  name: "EventSeriesStatus" as const,
  displayName: "Event Series Status",
  type: "enum",
  ...getEnumMeta<"Draft"|"Published"|"Cancelled">([
  {
    value: 0,
    strValue: "Draft",
    displayName: "Draft",
  },
  {
    value: 1,
    strValue: "Published",
    displayName: "Published",
  },
  {
    value: 2,
    strValue: "Cancelled",
    displayName: "Cancelled",
  },
  ]),
}
export const PassCategory = domain.enums.PassCategory = {
  name: "PassCategory" as const,
  displayName: "Pass Category",
  type: "enum",
  ...getEnumMeta<"SingleDay"|"MultiDay">([
  {
    value: 0,
    strValue: "SingleDay",
    displayName: "Single Day",
  },
  {
    value: 1,
    strValue: "MultiDay",
    displayName: "Multi Day",
  },
  ]),
}
export const PaymentKind = domain.enums.PaymentKind = {
  name: "PaymentKind" as const,
  displayName: "Payment Kind",
  type: "enum",
  ...getEnumMeta<"Payment"|"CreditCardPayment"|"Comp"|"API">([
  {
    value: 0,
    strValue: "Payment",
    displayName: "Payment",
  },
  {
    value: 1,
    strValue: "CreditCardPayment",
    displayName: "Credit Card",
  },
  {
    value: 2,
    strValue: "Comp",
    displayName: "Comp",
  },
  {
    value: 3,
    strValue: "API",
    displayName: "API",
  },
  ]),
}
export const PurchaseStatus = domain.enums.PurchaseStatus = {
  name: "PurchaseStatus" as const,
  displayName: "Purchase Status",
  type: "enum",
  ...getEnumMeta<"Started"|"Completed"|"Canceled"|"Expired">([
  {
    value: 0,
    strValue: "Started",
    displayName: "Started",
  },
  {
    value: 1,
    strValue: "Completed",
    displayName: "Completed",
  },
  {
    value: 2,
    strValue: "Canceled",
    displayName: "Canceled",
  },
  {
    value: 3,
    strValue: "Expired",
    displayName: "Expired",
  },
  ]),
}
export const PurchaseType = domain.enums.PurchaseType = {
  name: "PurchaseType" as const,
  displayName: "Purchase Type",
  type: "enum",
  ...getEnumMeta<"Purchase"|"Exchange"|"Refund"|"Comp"|"API">([
  {
    value: 0,
    strValue: "Purchase",
    displayName: "Purchase",
  },
  {
    value: 1,
    strValue: "Exchange",
    displayName: "Exchange",
  },
  {
    value: 2,
    strValue: "Refund",
    displayName: "Refund",
  },
  {
    value: 3,
    strValue: "Comp",
    displayName: "Comp",
  },
  {
    value: 4,
    strValue: "API",
    displayName: "API Purchase",
  },
  ]),
}
export const RefundableState = domain.enums.RefundableState = {
  name: "RefundableState" as const,
  displayName: "Refundable State",
  type: "enum",
  ...getEnumMeta<"NotOffered"|"Purchased"|"Declined"|"NotSelected">([
  {
    value: 0,
    strValue: "NotOffered",
    displayName: "Not Offered",
  },
  {
    value: 1,
    strValue: "Purchased",
    displayName: "Purchased",
  },
  {
    value: 2,
    strValue: "Declined",
    displayName: "Declined",
  },
  {
    value: 3,
    strValue: "NotSelected",
    displayName: "Not Selected",
  },
  ]),
}
export const SeatMapAnnotationShape = domain.enums.SeatMapAnnotationShape = {
  name: "SeatMapAnnotationShape" as const,
  displayName: "Seat Map Annotation Shape",
  type: "enum",
  ...getEnumMeta<"Rectangle"|"RoundedRectangle"|"Oval"|"None">([
  {
    value: 0,
    strValue: "Rectangle",
    displayName: "Rectangle",
  },
  {
    value: 1,
    strValue: "RoundedRectangle",
    displayName: "Rounded Rectangle",
  },
  {
    value: 2,
    strValue: "Oval",
    displayName: "Oval",
  },
  {
    value: 3,
    strValue: "None",
    displayName: "None",
  },
  ]),
}
export const SeatMapMethodEnum = domain.enums.SeatMapMethodEnum = {
  name: "SeatMapMethodEnum" as const,
  displayName: "Seat Map Method Enum",
  type: "enum",
  ...getEnumMeta<"Legacy"|"SoftJourn">([
  {
    value: 0,
    strValue: "Legacy",
    displayName: "Legacy",
  },
  {
    value: 1,
    strValue: "SoftJourn",
    displayName: "SoftJourn",
  },
  ]),
}
export const SectionTypes = domain.enums.SectionTypes = {
  name: "SectionTypes" as const,
  displayName: "Section Types",
  type: "enum",
  ...getEnumMeta<"IndividualSeat"|"GeneralAdmission">([
  {
    value: 0,
    strValue: "IndividualSeat",
    displayName: "Individual Seat",
  },
  {
    value: 1,
    strValue: "GeneralAdmission",
    displayName: "General Admission",
  },
  ]),
}
export const TextMessagingType = domain.enums.TextMessagingType = {
  name: "TextMessagingType" as const,
  displayName: "Text Messaging Type",
  type: "enum",
  ...getEnumMeta<"Announcement"|"Marketing"|"Cancellation"|"Confirmation">([
  {
    value: 0,
    strValue: "Announcement",
    displayName: "Announcement",
  },
  {
    value: 1,
    strValue: "Marketing",
    displayName: "Marketing",
  },
  {
    value: 2,
    strValue: "Cancellation",
    displayName: "Cancellation",
  },
  {
    value: 3,
    strValue: "Confirmation",
    displayName: "Confirmation",
  },
  ]),
}
export const TicketStatus = domain.enums.TicketStatus = {
  name: "TicketStatus" as const,
  displayName: "Ticket Status",
  type: "enum",
  ...getEnumMeta<"Completed"|"Hold"|"Exchanged"|"Refunded">([
  {
    value: 0,
    strValue: "Completed",
    displayName: "Completed",
  },
  {
    value: 1,
    strValue: "Hold",
    displayName: "Hold",
  },
  {
    value: 2,
    strValue: "Exchanged",
    displayName: "Exchanged",
  },
  {
    value: 3,
    strValue: "Refunded",
    displayName: "Refunded",
  },
  ]),
}
export const EventDateDto = domain.types.EventDateDto = {
  name: "EventDateDto" as const,
  displayName: "Event Date Dto",
  get displayProp() { return this.props.id }, 
  type: "model",
  controllerRoute: "EventDateDto",
  get keyProp() { return this.props.id }, 
  behaviorFlags: 0 as BehaviorFlags,
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "primaryKey",
      hidden: 3 as HiddenAreas,
    },
    eventStartDateTime: {
      name: "eventStartDateTime",
      displayName: "Event Start Date Time",
      type: "date",
      dateKind: "datetime",
      role: "value",
    },
    eventEndDateTime: {
      name: "eventEndDateTime",
      displayName: "Event End Date Time",
      type: "date",
      dateKind: "datetime",
      role: "value",
    },
    eventPublicPurchaseDatetime: {
      name: "eventPublicPurchaseDatetime",
      displayName: "Event Public Purchase Datetime",
      type: "date",
      dateKind: "datetime",
      role: "value",
    },
    eventStartDateTimeLocal: {
      name: "eventStartDateTimeLocal",
      displayName: "Event Start Date Time Local",
      type: "date",
      dateKind: "datetime",
      noOffset: true,
      role: "value",
      dontSerialize: true,
    },
    eventEndDateTimeLocal: {
      name: "eventEndDateTimeLocal",
      displayName: "Event End Date Time Local",
      type: "date",
      dateKind: "datetime",
      noOffset: true,
      role: "value",
      dontSerialize: true,
    },
    venueTimezone: {
      name: "venueTimezone",
      displayName: "Venue Timezone",
      type: "string",
      role: "value",
    },
    durationMinutes: {
      name: "durationMinutes",
      displayName: "Duration Minutes",
      type: "number",
      role: "value",
    },
    eventCapacity: {
      name: "eventCapacity",
      displayName: "Event Capacity",
      type: "number",
      role: "value",
    },
    cancelled: {
      name: "cancelled",
      displayName: "Cancelled",
      type: "boolean",
      role: "value",
    },
    eventId: {
      name: "eventId",
      displayName: "Event Id",
      type: "number",
      role: "value",
    },
    eventName: {
      name: "eventName",
      displayName: "Event Name",
      type: "string",
      role: "value",
    },
    eventColor: {
      name: "eventColor",
      displayName: "Event Color",
      type: "string",
      role: "value",
    },
    eventShortDescription: {
      name: "eventShortDescription",
      displayName: "Event Short Description",
      type: "string",
      role: "value",
    },
    eventLongDescription: {
      name: "eventLongDescription",
      displayName: "Event Long Description",
      type: "string",
      role: "value",
    },
    eventLocation: {
      name: "eventLocation",
      displayName: "Event Location",
      type: "string",
      role: "value",
    },
    eventBoardingLabel: {
      name: "eventBoardingLabel",
      displayName: "Event Boarding Label",
      type: "string",
      role: "value",
    },
    eventBoardingMinutes: {
      name: "eventBoardingMinutes",
      displayName: "Event Boarding Minutes",
      type: "number",
      role: "value",
    },
    hasFood: {
      name: "hasFood",
      displayName: "Has Food",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    availableSeats: {
      name: "availableSeats",
      displayName: "Available Seats",
      type: "number",
      role: "value",
    },
    customMoreOptionsButtonText: {
      name: "customMoreOptionsButtonText",
      displayName: "Custom More Options Button Text",
      type: "string",
      role: "value",
    },
    customMoreOptionsIcon: {
      name: "customMoreOptionsIcon",
      displayName: "Custom More Options Icon",
      type: "string",
      role: "value",
    },
    customMoreOptionsUrl: {
      name: "customMoreOptionsUrl",
      displayName: "Custom More Options Url",
      type: "string",
      role: "value",
    },
    customSelectTicketsUrl: {
      name: "customSelectTicketsUrl",
      displayName: "Custom Select Tickets Url",
      type: "string",
      role: "value",
    },
    customSelectTicketsButtonText: {
      name: "customSelectTicketsButtonText",
      displayName: "Custom Select Tickets Button Text",
      type: "string",
      role: "value",
    },
    customSelectTicketsIcon: {
      name: "customSelectTicketsIcon",
      displayName: "Custom Select Tickets Icon",
      type: "string",
      role: "value",
    },
    isSeated: {
      name: "isSeated",
      displayName: "Is Seated",
      type: "boolean",
      role: "value",
    },
    soldOut: {
      name: "soldOut",
      displayName: "Sold Out",
      type: "boolean",
      role: "value",
    },
    eventCustomSoldOutText: {
      name: "eventCustomSoldOutText",
      displayName: "Event Custom Sold Out Text",
      type: "string",
      role: "value",
    },
    isEventActive: {
      name: "isEventActive",
      displayName: "Is Event Active",
      type: "boolean",
      role: "value",
    },
    isFreeEvent: {
      name: "isFreeEvent",
      displayName: "Is Free Event",
      type: "boolean",
      role: "value",
    },
    requiresAccessCode: {
      name: "requiresAccessCode",
      displayName: "Requires Access Code",
      type: "boolean",
      role: "value",
    },
    hiddenFromInitialPurchase: {
      name: "hiddenFromInitialPurchase",
      displayName: "Hidden From Initial Purchase",
      type: "boolean",
      role: "value",
    },
    isTenantCustomMoreOptionsButtonEnabled: {
      name: "isTenantCustomMoreOptionsButtonEnabled",
      displayName: "Is Tenant Custom More Options Button Enabled",
      type: "boolean",
      role: "value",
    },
    statusDescription: {
      name: "statusDescription",
      displayName: "Status Description",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    unpurchasableReason: {
      name: "unpurchasableReason",
      displayName: "Unpurchasable Reason",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    eventPrices: {
      name: "eventPrices",
      displayName: "Event Prices",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventPriceDto as ObjectType & { name: "EventPriceDto" }) },
      },
      role: "value",
      dontSerialize: true,
    },
    eventBannerImage: {
      name: "eventBannerImage",
      displayName: "Event Banner Image",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    gridViewImage: {
      name: "gridViewImage",
      displayName: "Grid View Image",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    eventImages: {
      name: "eventImages",
      displayName: "Event Images",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventImageDto as ObjectType & { name: "EventImageDto" }) },
      },
      role: "value",
      dontSerialize: true,
    },
    isSeries: {
      name: "isSeries",
      displayName: "Is Series",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    seriesId: {
      name: "seriesId",
      displayName: "Series Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    seriesEndDateTimeLocal: {
      name: "seriesEndDateTimeLocal",
      displayName: "Series End Date Time Local",
      type: "date",
      dateKind: "datetime",
      noOffset: true,
      role: "value",
      dontSerialize: true,
    },
  },
  methods: {
  },
  dataSources: {
    calendarSource: {
      type: "dataSource",
      name: "CalendarSource" as const,
      displayName: "Calendar Source",
      props: {
        year: {
          name: "year",
          displayName: "Year",
          type: "number",
          role: "value",
        },
        month: {
          name: "month",
          displayName: "Month",
          type: "number",
          role: "value",
        },
        collapseSeries: {
          name: "collapseSeries",
          displayName: "Collapse Series",
          type: "boolean",
          role: "value",
        },
        seriesId: {
          name: "seriesId",
          displayName: "Series Id",
          type: "number",
          role: "value",
        },
        includeForWeb: {
          name: "includeForWeb",
          displayName: "Include For Web",
          type: "boolean",
          role: "value",
        },
        includeWebUnlisted: {
          name: "includeWebUnlisted",
          displayName: "Include Web Unlisted",
          type: "boolean",
          role: "value",
        },
        includeForPos: {
          name: "includeForPos",
          displayName: "Include For Pos",
          type: "boolean",
          role: "value",
        },
        includeSoldOut: {
          name: "includeSoldOut",
          displayName: "Include Sold Out",
          type: "boolean",
          role: "value",
        },
        includeInactive: {
          name: "includeInactive",
          displayName: "Include Inactive",
          type: "boolean",
          role: "value",
        },
        includeCancelled: {
          name: "includeCancelled",
          displayName: "Include Cancelled",
          type: "boolean",
          role: "value",
        },
        minDate: {
          name: "minDate",
          displayName: "Min Date",
          type: "date",
          dateKind: "datetime",
          role: "value",
        },
        onlyPast: {
          name: "onlyPast",
          displayName: "Only Past",
          type: "boolean",
          role: "value",
        },
        eventTypeId: {
          name: "eventTypeId",
          displayName: "Event Type Id",
          type: "number",
          role: "value",
        },
      },
    },
    defaultSource: {
      type: "dataSource",
      name: "DefaultSource" as const,
      displayName: "Default Source",
      isDefault: true,
      props: {
        collapseSeries: {
          name: "collapseSeries",
          displayName: "Collapse Series",
          type: "boolean",
          role: "value",
        },
        seriesId: {
          name: "seriesId",
          displayName: "Series Id",
          type: "number",
          role: "value",
        },
        includeForWeb: {
          name: "includeForWeb",
          displayName: "Include For Web",
          type: "boolean",
          role: "value",
        },
        includeWebUnlisted: {
          name: "includeWebUnlisted",
          displayName: "Include Web Unlisted",
          type: "boolean",
          role: "value",
        },
        includeForPos: {
          name: "includeForPos",
          displayName: "Include For Pos",
          type: "boolean",
          role: "value",
        },
        includeSoldOut: {
          name: "includeSoldOut",
          displayName: "Include Sold Out",
          type: "boolean",
          role: "value",
        },
        includeInactive: {
          name: "includeInactive",
          displayName: "Include Inactive",
          type: "boolean",
          role: "value",
        },
        includeCancelled: {
          name: "includeCancelled",
          displayName: "Include Cancelled",
          type: "boolean",
          role: "value",
        },
        minDate: {
          name: "minDate",
          displayName: "Min Date",
          type: "date",
          dateKind: "datetime",
          role: "value",
        },
        onlyPast: {
          name: "onlyPast",
          displayName: "Only Past",
          type: "boolean",
          role: "value",
        },
        eventTypeId: {
          name: "eventTypeId",
          displayName: "Event Type Id",
          type: "number",
          role: "value",
        },
      },
    },
  },
}
export const EventDto = domain.types.EventDto = {
  name: "EventDto" as const,
  displayName: "Event Dto",
  get displayProp() { return this.props.description }, 
  type: "model",
  controllerRoute: "EventDto",
  get keyProp() { return this.props.id }, 
  behaviorFlags: 0 as BehaviorFlags,
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "primaryKey",
      hidden: 3 as HiddenAreas,
    },
    description: {
      name: "description",
      displayName: "Description",
      type: "string",
      role: "value",
    },
  },
  methods: {
  },
  dataSources: {
    defaultSource: {
      type: "dataSource",
      name: "DefaultSource" as const,
      displayName: "Default Source",
      isDefault: true,
      props: {
      },
    },
  },
}
export const EventTypeDto = domain.types.EventTypeDto = {
  name: "EventTypeDto" as const,
  displayName: "Event Type Dto",
  get displayProp() { return this.props.description }, 
  type: "model",
  controllerRoute: "EventTypeDto",
  get keyProp() { return this.props.id }, 
  behaviorFlags: 0 as BehaviorFlags,
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "primaryKey",
      hidden: 3 as HiddenAreas,
    },
    description: {
      name: "description",
      displayName: "Description",
      type: "string",
      role: "value",
    },
  },
  methods: {
  },
  dataSources: {
    defaultSource: {
      type: "dataSource",
      name: "DefaultSource" as const,
      displayName: "Default Source",
      isDefault: true,
      props: {
      },
    },
  },
}
export const TicketPurchaseDto = domain.types.TicketPurchaseDto = {
  name: "TicketPurchaseDto" as const,
  displayName: "Ticket Purchase Dto",
  get displayProp() { return this.props.publicId }, 
  type: "model",
  controllerRoute: "TicketPurchaseDto",
  get keyProp() { return this.props.publicId }, 
  behaviorFlags: 2 as BehaviorFlags,
  props: {
    publicId: {
      name: "publicId",
      displayName: "Public Id",
      type: "string",
      role: "primaryKey",
      hidden: 3 as HiddenAreas,
    },
    firstName: {
      name: "firstName",
      displayName: "First Name",
      type: "string",
      role: "value",
    },
    lastName: {
      name: "lastName",
      displayName: "Last Name",
      type: "string",
      role: "value",
    },
    email: {
      name: "email",
      displayName: "Email",
      type: "string",
      role: "value",
    },
    phone: {
      name: "phone",
      displayName: "Phone",
      type: "string",
      role: "value",
    },
    marketingOptOut: {
      name: "marketingOptOut",
      displayName: "Marketing Opt Out",
      type: "boolean",
      role: "value",
    },
    refundable: {
      name: "refundable",
      displayName: "Refundable",
      type: "enum",
      get typeDef() { return RefundableState },
      role: "value",
    },
    isAllowTextMessaging: {
      name: "isAllowTextMessaging",
      displayName: "Is Allow Text Messaging",
      type: "boolean",
      role: "value",
    },
    tenantTextMessagingEnabled: {
      name: "tenantTextMessagingEnabled",
      displayName: "Tenant Text Messaging Enabled",
      type: "boolean",
      role: "value",
    },
    showRemainingSeats: {
      name: "showRemainingSeats",
      displayName: "Show Remaining Seats",
      type: "boolean",
      role: "value",
    },
    addressStreet: {
      name: "addressStreet",
      displayName: "Address Street",
      type: "string",
      role: "value",
    },
    addressCity: {
      name: "addressCity",
      displayName: "Address City",
      type: "string",
      role: "value",
    },
    addressState: {
      name: "addressState",
      displayName: "Address State",
      type: "string",
      role: "value",
    },
    addressZip: {
      name: "addressZip",
      displayName: "Address Zip",
      type: "string",
      role: "value",
    },
    addressCountry: {
      name: "addressCountry",
      displayName: "Address Country",
      type: "string",
      role: "value",
    },
    roomNumber: {
      name: "roomNumber",
      displayName: "Room Number",
      type: "string",
      role: "value",
    },
    willCall: {
      name: "willCall",
      displayName: "Will Call",
      type: "boolean",
      role: "value",
    },
    waiveTicketFees: {
      name: "waiveTicketFees",
      displayName: "Waive Ticket Fees",
      type: "boolean",
      role: "value",
    },
    canWaiveTicketFees: {
      name: "canWaiveTicketFees",
      displayName: "Can Waive Ticket Fees",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Creation Date",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
    expirationDate: {
      name: "expirationDate",
      displayName: "Expiration Date",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
    isPublic: {
      name: "isPublic",
      displayName: "Is Public",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    hideServiceFee: {
      name: "hideServiceFee",
      displayName: "Hide Service Fee",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    absorbProcessingFee: {
      name: "absorbProcessingFee",
      displayName: "Absorb Processing Fee",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    absorbedTax: {
      name: "absorbedTax",
      displayName: "Absorbed Tax",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    type: {
      name: "type",
      displayName: "Type",
      type: "enum",
      get typeDef() { return PurchaseType },
      role: "value",
      dontSerialize: true,
    },
    status: {
      name: "status",
      displayName: "Status",
      type: "enum",
      get typeDef() { return PurchaseStatus },
      role: "value",
      dontSerialize: true,
    },
    failureMessage: {
      name: "failureMessage",
      displayName: "Failure Message",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    refundComment: {
      name: "refundComment",
      displayName: "Refund Comment",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    confirmationCode: {
      name: "confirmationCode",
      displayName: "Confirmation Code",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    refundPolicy: {
      name: "refundPolicy",
      displayName: "Refund Policy",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    refundableFee: {
      name: "refundableFee",
      displayName: "Refundable Fee",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    refundedRefundableFee: {
      name: "refundedRefundableFee",
      displayName: "Refunded Refundable Fee",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    refundableFeePercentage: {
      name: "refundableFeePercentage",
      displayName: "Refundable Fee Percentage",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    convenienceFee: {
      name: "convenienceFee",
      displayName: "Convenience Fee",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    refundedConvenienceFee: {
      name: "refundedConvenienceFee",
      displayName: "Refunded Convenience Fee",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    salesTax: {
      name: "salesTax",
      displayName: "Sales Tax",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    refundedSalesTax: {
      name: "refundedSalesTax",
      displayName: "Refunded Sales Tax",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    theoreticalSalesTax: {
      name: "theoreticalSalesTax",
      displayName: "Theoretical Sales Tax",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    absorbedSalesTaxAmount: {
      name: "absorbedSalesTaxAmount",
      displayName: "Absorbed Sales Tax Amount",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    balance: {
      name: "balance",
      displayName: "Balance",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    grandTotal: {
      name: "grandTotal",
      displayName: "Grand Total",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    eventDateId: {
      name: "eventDateId",
      displayName: "Event Date Id",
      type: "number",
      role: "foreignKey",
      get principalKey() { return (domain.types.EventDateDto as ModelType & { name: "EventDateDto" }).props.id as PrimaryKeyProperty },
      get principalType() { return (domain.types.EventDateDto as ModelType & { name: "EventDateDto" }) },
      get navigationProp() { return (domain.types.TicketPurchaseDto as ModelType & { name: "TicketPurchaseDto" }).props.eventDate as ModelReferenceNavigationProperty },
      hidden: 3 as HiddenAreas,
      dontSerialize: true,
    },
    eventDate: {
      name: "eventDate",
      displayName: "Event Date",
      type: "model",
      get typeDef() { return (domain.types.EventDateDto as ModelType & { name: "EventDateDto" }) },
      role: "referenceNavigation",
      get foreignKey() { return (domain.types.TicketPurchaseDto as ModelType & { name: "TicketPurchaseDto" }).props.eventDateId as ForeignKeyProperty },
      get principalKey() { return (domain.types.EventDateDto as ModelType & { name: "EventDateDto" }).props.id as PrimaryKeyProperty },
      dontSerialize: true,
    },
    eventSeriesId: {
      name: "eventSeriesId",
      displayName: "Event Series Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    eventSeries: {
      name: "eventSeries",
      displayName: "Event Series",
      type: "object",
      get typeDef() { return (domain.types.EventSeries as ObjectType & { name: "EventSeries" }) },
      role: "value",
      dontSerialize: true,
    },
    passTypeId: {
      name: "passTypeId",
      displayName: "Pass Type Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    coveredSeriesDates: {
      name: "coveredSeriesDates",
      displayName: "Covered Series Dates",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.SeriesCoveredDate as ObjectType & { name: "SeriesCoveredDate" }) },
      },
      role: "value",
      dontSerialize: true,
    },
    venueDisclaimer: {
      name: "venueDisclaimer",
      displayName: "Venue Disclaimer",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    isTicketDeliveryHeld: {
      name: "isTicketDeliveryHeld",
      displayName: "Is Ticket Delivery Held",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    ticketDeliveryReleaseDateTime: {
      name: "ticketDeliveryReleaseDateTime",
      displayName: "Ticket Delivery Release Date Time",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
    ticketDeliveryReleaseDateDisplay: {
      name: "ticketDeliveryReleaseDateDisplay",
      displayName: "Ticket Delivery Release Date Display",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    ticketDeliveryReleaseTimeDisplay: {
      name: "ticketDeliveryReleaseTimeDisplay",
      displayName: "Ticket Delivery Release Time Display",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    ticketDeliveryReleaseTimeZoneDisplay: {
      name: "ticketDeliveryReleaseTimeZoneDisplay",
      displayName: "Ticket Delivery Release Time Zone Display",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    ticketDeliveryEventStartDisplay: {
      name: "ticketDeliveryEventStartDisplay",
      displayName: "Ticket Delivery Event Start Display",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    venueId: {
      name: "venueId",
      displayName: "Venue Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    tickets: {
      name: "tickets",
      displayName: "Tickets",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.TicketPurchaseTicket as ObjectType & { name: "TicketPurchaseTicket" }) },
      },
      role: "value",
      dontSerialize: true,
    },
    addons: {
      name: "addons",
      displayName: "Addons",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.TicketPurchaseAddon as ObjectType & { name: "TicketPurchaseAddon" }) },
      },
      role: "value",
      dontSerialize: true,
    },
    discounts: {
      name: "discounts",
      displayName: "Discounts",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.TicketPurchaseDiscount as ObjectType & { name: "TicketPurchaseDiscount" }) },
      },
      role: "value",
      dontSerialize: true,
    },
    payments: {
      name: "payments",
      displayName: "Payments",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.TicketPurchasePayment as ObjectType & { name: "TicketPurchasePayment" }) },
      },
      role: "value",
      dontSerialize: true,
    },
    dietaryRestrictions: {
      name: "dietaryRestrictions",
      displayName: "Dietary Restrictions",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.TicketPurchaseDietaryRestriction as ObjectType & { name: "TicketPurchaseDietaryRestriction" }) },
      },
      role: "value",
      dontSerialize: true,
    },
    availableAddons: {
      name: "availableAddons",
      displayName: "Available Addons",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventAddonDto as ObjectType & { name: "EventAddonDto" }) },
      },
      role: "value",
      dontSerialize: true,
    },
    eventSuggestedEvents: {
      name: "eventSuggestedEvents",
      displayName: "Event Suggested Events",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventSuggestedEvent as ObjectType & { name: "EventSuggestedEvent" }) },
      },
      role: "value",
      dontSerialize: true,
    },
    originalPurchase: {
      name: "originalPurchase",
      displayName: "Original Purchase",
      type: "object",
      get typeDef() { return (domain.types.TicketPurchaseRelatedPurchase as ObjectType & { name: "TicketPurchaseRelatedPurchase" }) },
      role: "value",
      dontSerialize: true,
    },
    ticketPriceBreakdowns: {
      name: "ticketPriceBreakdowns",
      displayName: "Ticket Price Breakdowns",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.TicketPriceBreakdown as ObjectType & { name: "TicketPriceBreakdown" }) },
      },
      role: "value",
      dontSerialize: true,
    },
    refundOverrideLog: {
      name: "refundOverrideLog",
      displayName: "Refund Override Log",
      type: "object",
      get typeDef() { return (domain.types.RefundOverrideLog as ObjectType & { name: "RefundOverrideLog" }) },
      role: "value",
      dontSerialize: true,
    },
  },
  methods: {
  },
  dataSources: {
    defaultSource: {
      type: "dataSource",
      name: "DefaultSource" as const,
      displayName: "Default Source",
      isDefault: true,
      props: {
      },
    },
  },
}
export const AddonItemConfiguration = domain.types.AddonItemConfiguration = {
  name: "AddonItemConfiguration" as const,
  displayName: "Addon Item Configuration",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    addonItemDefinitionId: {
      name: "addonItemDefinitionId",
      displayName: "Addon Item Definition Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    addonItemDefinition: {
      name: "addonItemDefinition",
      displayName: "Addon Item Definition",
      type: "object",
      get typeDef() { return (domain.types.AddonItemDefinition as ObjectType & { name: "AddonItemDefinition" }) },
      role: "value",
    },
    name: {
      name: "name",
      displayName: "Name",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Name is required.",
      }
    },
    marketingDescription: {
      name: "marketingDescription",
      displayName: "Marketing Description",
      type: "string",
      role: "value",
    },
    hasQuantity: {
      name: "hasQuantity",
      displayName: "Has Quantity",
      type: "boolean",
      role: "value",
    },
    type: {
      name: "type",
      displayName: "Type",
      type: "enum",
      get typeDef() { return AddonItemType },
      role: "value",
    },
    fixedAmount: {
      name: "fixedAmount",
      displayName: "Fixed Amount",
      type: "number",
      role: "value",
    },
    percentAmount: {
      name: "percentAmount",
      displayName: "Percent Amount",
      type: "number",
      role: "value",
    },
    ticketTemplateId: {
      name: "ticketTemplateId",
      displayName: "Ticket Template Id",
      type: "number",
      role: "value",
    },
    ticketTemplate: {
      name: "ticketTemplate",
      displayName: "Ticket Template",
      type: "object",
      get typeDef() { return (domain.types.TicketTemplate as ObjectType & { name: "TicketTemplate" }) },
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const AddonItemDefinition = domain.types.AddonItemDefinition = {
  name: "AddonItemDefinition" as const,
  displayName: "Add-on Item Definition",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    name: {
      name: "name",
      displayName: "Name",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Name is required.",
      }
    },
    adminNote: {
      name: "adminNote",
      displayName: "Admin Note",
      type: "string",
      role: "value",
    },
    currentConfigurationId: {
      name: "currentConfigurationId",
      displayName: "Current Configuration Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    currentConfiguration: {
      name: "currentConfiguration",
      displayName: "Current Configuration",
      type: "object",
      get typeDef() { return (domain.types.AddonItemConfiguration as ObjectType & { name: "AddonItemConfiguration" }) },
      role: "value",
      hidden: 3 as HiddenAreas,
    },
    dailyMaximumQuantity: {
      name: "dailyMaximumQuantity",
      displayName: "Daily Maximum Quantity",
      type: "number",
      role: "value",
    },
    eventDateTimeMaximumQuantity: {
      name: "eventDateTimeMaximumQuantity",
      displayName: "Event Date Time Maximum Quantity",
      type: "number",
      role: "value",
    },
    showOnPatronManifest: {
      name: "showOnPatronManifest",
      displayName: "Show On Patron Manifest",
      type: "boolean",
      role: "value",
    },
    isHidden: {
      name: "isHidden",
      displayName: "Is Hidden",
      type: "boolean",
      role: "value",
      hidden: 3 as HiddenAreas,
      defaultValue: false,
    },
    purchaseNotificationEmail: {
      name: "purchaseNotificationEmail",
      displayName: "Purchase Notification Email",
      type: "string",
      role: "value",
    },
    eventAddonItems: {
      name: "eventAddonItems",
      displayName: "Event Addon Items",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventAddonItemDefinition as ObjectType & { name: "EventAddonItemDefinition" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const AppRole = domain.types.AppRole = {
  name: "AppRole" as const,
  displayName: "App Role",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    name: {
      name: "name",
      displayName: "Name",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Name is required.",
      }
    },
    id: {
      name: "id",
      displayName: "Id",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Id is required.",
      }
    },
  },
}
export const AppUser = domain.types.AppUser = {
  name: "AppUser" as const,
  displayName: "App User",
  get displayProp() { return this.props.userName }, 
  type: "object",
  props: {
    userName: {
      name: "userName",
      displayName: "User Name",
      type: "string",
      role: "value",
    },
    firstName: {
      name: "firstName",
      displayName: "First Name",
      type: "string",
      role: "value",
    },
    lastName: {
      name: "lastName",
      displayName: "Last Name",
      type: "string",
      role: "value",
    },
    receiveLowInventoryNotifications: {
      name: "receiveLowInventoryNotifications",
      displayName: "Receive Low Inventory Notifications",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    userRoles: {
      name: "userRoles",
      displayName: "User Roles",
      description: "The user's roles within the current tenant.",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.AppUserRole as ObjectType & { name: "AppUserRole" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    appUserAllTenantRoles: {
      name: "appUserAllTenantRoles",
      displayName: "All-tenant Roles",
      description: "Roles assigned to the user when they log into any tenant. Implicitly grants membership to all tenants.",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.AppUserAllTenantRole as ObjectType & { name: "AppUserAllTenantRole" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    roleNames: {
      name: "roleNames",
      displayName: "Roles",
      description: "The user's roles within the current tenant.",
      type: "string",
      subtype: "multiline",
      role: "value",
      dontSerialize: true,
    },
    tenantMemberships: {
      name: "tenantMemberships",
      displayName: "Tenant Memberships",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.TenantMembership as ObjectType & { name: "TenantMembership" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    isTenantAdmin: {
      name: "isTenantAdmin",
      displayName: "Is Tenant Admin",
      description: "Tenant admins are able to create and edit tenants and tenant metadata, and assign all-tenant roles. This role transcends any particular tenant.",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    email: {
      name: "email",
      displayName: "Email",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    emailConfirmed: {
      name: "emailConfirmed",
      displayName: "Email Confirmed",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    accessFailedCount: {
      name: "accessFailedCount",
      displayName: "Access Failed Count",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    lockoutEnd: {
      name: "lockoutEnd",
      displayName: "Lockout End",
      type: "date",
      dateKind: "datetime",
      role: "value",
    },
    id: {
      name: "id",
      displayName: "Id",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Id is required.",
      }
    },
  },
}
export const AppUserAllTenantRole = domain.types.AppUserAllTenantRole = {
  name: "AppUserAllTenantRole" as const,
  displayName: "App User All Tenant Role",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    userId: {
      name: "userId",
      displayName: "User Id",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "User Id is required.",
      }
    },
    user: {
      name: "user",
      displayName: "User",
      type: "object",
      get typeDef() { return (domain.types.AppUser as ObjectType & { name: "AppUser" }) },
      role: "value",
    },
    roleId: {
      name: "roleId",
      displayName: "Role Id",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Role Id is required.",
      }
    },
    role: {
      name: "role",
      displayName: "Role",
      type: "object",
      get typeDef() { return (domain.types.AppRole as ObjectType & { name: "AppRole" }) },
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const AppUserRole = domain.types.AppUserRole = {
  name: "AppUserRole" as const,
  displayName: "App User Role",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "string",
      role: "value",
    },
    userId: {
      name: "userId",
      displayName: "User Id",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "User Id is required.",
      }
    },
    user: {
      name: "user",
      displayName: "User",
      type: "object",
      get typeDef() { return (domain.types.AppUser as ObjectType & { name: "AppUser" }) },
      role: "value",
    },
    roleId: {
      name: "roleId",
      displayName: "Role Id",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Role Id is required.",
      }
    },
    role: {
      name: "role",
      displayName: "Role",
      type: "object",
      get typeDef() { return (domain.types.AppRole as ObjectType & { name: "AppRole" }) },
      role: "value",
    },
  },
}
export const AvailableSeatsDetails = domain.types.AvailableSeatsDetails = {
  name: "AvailableSeatsDetails" as const,
  displayName: "Available Seats Details",
  type: "object",
  props: {
    seatNumber: {
      name: "seatNumber",
      displayName: "Seat Number",
      type: "string",
      role: "value",
    },
    amountOfSeats: {
      name: "amountOfSeats",
      displayName: "Amount Of Seats",
      type: "number",
      role: "value",
    },
  },
}
export const Consignee = domain.types.Consignee = {
  name: "Consignee" as const,
  displayName: "Consignee",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    name: {
      name: "name",
      displayName: "Name",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Name is required.",
      }
    },
    address: {
      name: "address",
      displayName: "Address",
      type: "string",
      role: "value",
    },
    contactPhone: {
      name: "contactPhone",
      displayName: "Contact Phone",
      type: "string",
      role: "value",
    },
    taxId: {
      name: "taxId",
      displayName: "Tax Id",
      type: "string",
      role: "value",
    },
    consigneeDiscountDefinitions: {
      name: "consigneeDiscountDefinitions",
      displayName: "Consignee Discount Definitions",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.ConsigneeDiscountDefinition as ObjectType & { name: "ConsigneeDiscountDefinition" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    consigneeReps: {
      name: "consigneeReps",
      displayName: "Consignee Reps",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.ConsigneeRep as ObjectType & { name: "ConsigneeRep" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    consigneeCommissions: {
      name: "consigneeCommissions",
      displayName: "Consignee Commissions",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.ConsigneeCommission as ObjectType & { name: "ConsigneeCommission" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const ConsigneeCommission = domain.types.ConsigneeCommission = {
  name: "ConsigneeCommission" as const,
  displayName: "Consignee Commission",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    commissionPercent: {
      name: "commissionPercent",
      displayName: "Commission Percent",
      type: "number",
      role: "value",
    },
    commissionRate: {
      name: "commissionRate",
      displayName: "Commission Rate",
      type: "number",
      role: "value",
    },
    consigneeId: {
      name: "consigneeId",
      displayName: "Consignee Id",
      type: "number",
      role: "value",
    },
    consignee: {
      name: "consignee",
      displayName: "Consignee",
      type: "object",
      get typeDef() { return (domain.types.Consignee as ObjectType & { name: "Consignee" }) },
      role: "value",
    },
    isActive: {
      name: "isActive",
      displayName: "Is Active",
      type: "boolean",
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const ConsigneeDiscountDefinition = domain.types.ConsigneeDiscountDefinition = {
  name: "ConsigneeDiscountDefinition" as const,
  displayName: "Consignee Discount Definition",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    consigneeId: {
      name: "consigneeId",
      displayName: "Consignee Id",
      type: "number",
      role: "value",
    },
    discountDefinitionId: {
      name: "discountDefinitionId",
      displayName: "Discount Definition Id",
      type: "number",
      role: "value",
    },
    consignee: {
      name: "consignee",
      displayName: "Consignee",
      type: "object",
      get typeDef() { return (domain.types.Consignee as ObjectType & { name: "Consignee" }) },
      role: "value",
    },
    discountDefinition: {
      name: "discountDefinition",
      displayName: "Discount Definition",
      type: "object",
      get typeDef() { return (domain.types.DiscountDefinition as ObjectType & { name: "DiscountDefinition" }) },
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const ConsigneeRep = domain.types.ConsigneeRep = {
  name: "ConsigneeRep" as const,
  displayName: "Consignee Rep",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    consigneeId: {
      name: "consigneeId",
      displayName: "Consignee Id",
      type: "number",
      role: "value",
    },
    consignee: {
      name: "consignee",
      displayName: "Consignee",
      type: "object",
      get typeDef() { return (domain.types.Consignee as ObjectType & { name: "Consignee" }) },
      role: "value",
    },
    userId: {
      name: "userId",
      displayName: "User Id",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "User Id is required.",
      }
    },
    user: {
      name: "user",
      displayName: "User",
      type: "object",
      get typeDef() { return (domain.types.AppUser as ObjectType & { name: "AppUser" }) },
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const CreditCardDetails = domain.types.CreditCardDetails = {
  name: "CreditCardDetails" as const,
  displayName: "Credit Card Details",
  type: "object",
  props: {
    paymentId: {
      name: "paymentId",
      displayName: "Payment Id",
      type: "number",
      role: "value",
    },
    arqc: {
      name: "arqc",
      displayName: "Arqc",
      type: "string",
      role: "value",
    },
    cardNumber: {
      name: "cardNumber",
      displayName: "Card Number",
      type: "string",
      role: "value",
    },
    expirationMonth: {
      name: "expirationMonth",
      displayName: "Expiration Month",
      type: "number",
      role: "value",
    },
    expirationYear: {
      name: "expirationYear",
      displayName: "Expiration Year",
      type: "number",
      role: "value",
    },
    cvv: {
      name: "cvv",
      displayName: "Cvv",
      type: "string",
      role: "value",
    },
    billingAddress: {
      name: "billingAddress",
      displayName: "Billing Address",
      type: "string",
      role: "value",
    },
    billingZip: {
      name: "billingZip",
      displayName: "Billing Zip",
      type: "string",
      role: "value",
    },
    billingCountry: {
      name: "billingCountry",
      displayName: "Billing Country",
      type: "string",
      role: "value",
    },
    billingState: {
      name: "billingState",
      displayName: "Billing State",
      type: "string",
      role: "value",
    },
  },
}
export const DiscountDefinition = domain.types.DiscountDefinition = {
  name: "DiscountDefinition" as const,
  displayName: "Discount Definition",
  get displayProp() { return this.props.displayName }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    displayName: {
      name: "displayName",
      displayName: "Name",
      description: "The name of the discount, shown to patrons.",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Name is required.",
        maxLength: val => !val || val.length <= 100 || "Name may not be more than 100 characters.",
      }
    },
    details: {
      name: "details",
      displayName: "Internal Description",
      description: "An internal description of the discount, shown to admins and event managers.",
      type: "string",
      role: "value",
    },
    effectSummary: {
      name: "effectSummary",
      displayName: "Effect Summary",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    nonUniqueCode: {
      name: "nonUniqueCode",
      displayName: "Non Unique Code",
      type: "string",
      role: "value",
      rules: {
        maxLength: val => !val || val.length <= 20 || "Non Unique Code may not be more than 20 characters.",
      }
    },
    isActive: {
      name: "isActive",
      displayName: "Is Active",
      type: "boolean",
      role: "value",
    },
    availableOnWeb: {
      name: "availableOnWeb",
      displayName: "Available On Web",
      type: "boolean",
      role: "value",
    },
    availableOnPos: {
      name: "availableOnPos",
      displayName: "Available On Pos",
      type: "boolean",
      role: "value",
    },
    autoApply: {
      name: "autoApply",
      displayName: "Auto Apply",
      type: "boolean",
      role: "value",
    },
    isHidden: {
      name: "isHidden",
      displayName: "Is Hidden",
      type: "boolean",
      role: "value",
      hidden: 3 as HiddenAreas,
      defaultValue: false,
    },
    currentConfigurationId: {
      name: "currentConfigurationId",
      displayName: "Current Configuration Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    currentConfiguration: {
      name: "currentConfiguration",
      displayName: "Current Configuration",
      type: "object",
      get typeDef() { return (domain.types.DiscountDefinitionConfiguration as ObjectType & { name: "DiscountDefinitionConfiguration" }) },
      role: "value",
      hidden: 3 as HiddenAreas,
    },
    consigneeDiscountDefinitions: {
      name: "consigneeDiscountDefinitions",
      displayName: "Consignee Discount Definitions",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.ConsigneeDiscountDefinition as ObjectType & { name: "ConsigneeDiscountDefinition" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    eventDiscountDefinitions: {
      name: "eventDiscountDefinitions",
      displayName: "Event Discount Definitions",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventDiscountDefinition as ObjectType & { name: "EventDiscountDefinition" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    eventDateDiscountDefinitions: {
      name: "eventDateDiscountDefinitions",
      displayName: "Event Date Discount Definitions",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventDateDiscountDefinition as ObjectType & { name: "EventDateDiscountDefinition" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    isPairedWithCouponCodeGroup: {
      name: "isPairedWithCouponCodeGroup",
      displayName: "Is Paired With Coupon Code Group",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: false,
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const DiscountDefinitionConfiguration = domain.types.DiscountDefinitionConfiguration = {
  name: "DiscountDefinitionConfiguration" as const,
  displayName: "Discount Definition Configuration",
  get displayProp() { return this.props.displayName }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    discountDefinitionId: {
      name: "discountDefinitionId",
      displayName: "Discount Definition Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    discountDefinition: {
      name: "discountDefinition",
      displayName: "Discount Definition",
      type: "object",
      get typeDef() { return (domain.types.DiscountDefinition as ObjectType & { name: "DiscountDefinition" }) },
      role: "value",
    },
    displayName: {
      name: "displayName",
      displayName: "Name",
      description: "The name of the discount, shown to patrons.",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Name is required.",
        maxLength: val => !val || val.length <= 100 || "Name may not be more than 100 characters.",
      }
    },
    discountType: {
      name: "discountType",
      displayName: "Discount Type",
      type: "enum",
      get typeDef() { return DiscountType },
      role: "value",
      rules: {
        required: val => val != null || "Discount Type is required.",
      }
    },
    amountOff: {
      name: "amountOff",
      displayName: "Amount Off",
      type: "number",
      role: "value",
      rules: {
        min: val => val == null || val >= 0 || "Amount Off must be at least 0.",
        max: val => val == null || val <= 2147483647 || "Amount Off may not be more than 2147483647.",
      }
    },
    percentageOff: {
      name: "percentageOff",
      displayName: "Percentage Off",
      type: "number",
      role: "value",
      rules: {
        min: val => val == null || val >= 0 || "Percentage Off must be at least 0.",
        max: val => val == null || val <= 100 || "Percentage Off may not be more than 100.",
      }
    },
    minimumTicketCount: {
      name: "minimumTicketCount",
      displayName: "Amount of tickets sold for discount to apply",
      description: "The amount of tickets to be sold to apply discount.",
      type: "number",
      role: "value",
      rules: {
        min: val => val == null || val >= 0 || "Amount of tickets sold for discount to apply must be at least 0.",
        max: val => val == null || val <= 2147483647 || "Amount of tickets sold for discount to apply may not be more than 2147483647.",
      }
    },
    minimumPurchaseValue: {
      name: "minimumPurchaseValue",
      displayName: "Minimum price in one purchase to apply discount",
      description: "The minimum sum of Ticket Price (excluding all taxes and fees) required to use this discount.",
      type: "number",
      role: "value",
      rules: {
        min: val => val == null || val >= 0 || "Minimum price in one purchase to apply discount must be at least 0.",
        max: val => val == null || val <= 2147483647 || "Minimum price in one purchase to apply discount may not be more than 2147483647.",
      }
    },
    expireDaysBefore: {
      name: "expireDaysBefore",
      displayName: "Number of Days before the event discount expires",
      description: "The number of days before each event date when this discount becomes unavailable. A value of 0 disables date-based expiration.",
      type: "number",
      role: "value",
      rules: {
        min: val => val == null || val >= 0 || "Number of Days before the event discount expires must be at least 0.",
        max: val => val == null || val <= 365 || "Number of Days before the event discount expires may not be more than 365.",
      }
    },
    maximumUsagePerEventDate: {
      name: "maximumUsagePerEventDate",
      displayName: "Number of Discounts",
      description: "The number of times this discount can be applied per event date/time.",
      type: "number",
      role: "value",
      rules: {
        min: val => val == null || val >= 0 || "Number of Discounts must be at least 0.",
        max: val => val == null || val <= 2147483647 || "Number of Discounts may not be more than 2147483647.",
      }
    },
    effectSummary: {
      name: "effectSummary",
      displayName: "Effect Summary",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EmailTemplate = domain.types.EmailTemplate = {
  name: "EmailTemplate" as const,
  displayName: "Email Template",
  get displayProp() { return this.props.description }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    description: {
      name: "description",
      displayName: "Description",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Description is required.",
      }
    },
    subject: {
      name: "subject",
      displayName: "Subject",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Subject is required.",
      }
    },
    bodyText: {
      name: "bodyText",
      displayName: "Body Text",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    bodyHtml: {
      name: "bodyHtml",
      displayName: "Body Html",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      rules: {
        required: val => (val != null && val !== '') || "Body Html is required.",
      }
    },
    designJson: {
      name: "designJson",
      displayName: "Design Json",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    type: {
      name: "type",
      displayName: "Type",
      type: "enum",
      get typeDef() { return EmailType },
      role: "value",
    },
    isActive: {
      name: "isActive",
      displayName: "Is Active",
      type: "boolean",
      role: "value",
    },
    eventEmailTemplates: {
      name: "eventEmailTemplates",
      displayName: "Event Email Templates",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventEmailTemplate as ObjectType & { name: "EventEmailTemplate" }) },
      },
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const Event = domain.types.Event = {
  name: "Event" as const,
  displayName: "Event",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    name: {
      name: "name",
      displayName: "Name",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Name is required.",
      }
    },
    eventColor: {
      name: "eventColor",
      displayName: "Event Calendar Color",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    defaultCapacity: {
      name: "defaultCapacity",
      displayName: "Default Capacity",
      type: "number",
      role: "value",
    },
    boardingTime: {
      name: "boardingTime",
      displayName: "Boarding Time",
      type: "number",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    location: {
      name: "location",
      displayName: "Location",
      type: "string",
      role: "value",
    },
    shortDescription: {
      name: "shortDescription",
      displayName: "Short Description",
      type: "string",
      subtype: "multiline",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    longDescription: {
      name: "longDescription",
      displayName: "Long Description",
      type: "string",
      subtype: "multiline",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    customSoldOutText: {
      name: "customSoldOutText",
      displayName: "Custom Sold Out Text",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    isActive: {
      name: "isActive",
      displayName: "Is Active",
      type: "boolean",
      role: "value",
    },
    forSaleOnWeb: {
      name: "forSaleOnWeb",
      displayName: "For Sale On Web",
      type: "boolean",
      role: "value",
    },
    unlistedOnWeb: {
      name: "unlistedOnWeb",
      displayName: "Unlisted On Web",
      type: "boolean",
      role: "value",
    },
    forSaleOnPos: {
      name: "forSaleOnPos",
      displayName: "For Sale On Pos",
      type: "boolean",
      role: "value",
    },
    unlistedOnWebAfterFirstPurchase: {
      name: "unlistedOnWebAfterFirstPurchase",
      displayName: "Unlisted On Web After First Purchase",
      type: "boolean",
      role: "value",
    },
    updateCapacityToTicketCountAfterFirstPurchase: {
      name: "updateCapacityToTicketCountAfterFirstPurchase",
      displayName: "Update Capacity After First Purchase",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    hideServiceFee: {
      name: "hideServiceFee",
      displayName: "Hide Service Fee",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    customMoreOptionsButtonText: {
      name: "customMoreOptionsButtonText",
      displayName: "Custom More Options Button Text",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    customSelectTicketsButtonText: {
      name: "customSelectTicketsButtonText",
      displayName: "Custom More Options Button Text",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    customMoreOptionsIcon: {
      name: "customMoreOptionsIcon",
      displayName: "Custom More Options Icon",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    customSelectTicketsIcon: {
      name: "customSelectTicketsIcon",
      displayName: "Custom Select Tickets Icon",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    customMoreOptionsUrl: {
      name: "customMoreOptionsUrl",
      displayName: "Custom More Options Url",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    customSelectTicketsUrl: {
      name: "customSelectTicketsUrl",
      displayName: "Custom Select Tickets Url",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    eventTypeId: {
      name: "eventTypeId",
      displayName: "Event Type Id",
      type: "number",
      role: "value",
    },
    eventType: {
      name: "eventType",
      displayName: "Event Type",
      type: "object",
      get typeDef() { return (domain.types.EventType as ObjectType & { name: "EventType" }) },
      role: "value",
    },
    ticketTemplateId: {
      name: "ticketTemplateId",
      displayName: "Ticket Template Id",
      type: "number",
      role: "value",
    },
    ticketTemplate: {
      name: "ticketTemplate",
      displayName: "Ticket Template",
      type: "object",
      get typeDef() { return (domain.types.TicketTemplate as ObjectType & { name: "TicketTemplate" }) },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    confirmationEmailId: {
      name: "confirmationEmailId",
      displayName: "Confirmation Email Id",
      type: "number",
      role: "value",
    },
    confirmationEmail: {
      name: "confirmationEmail",
      displayName: "Confirmation Email",
      type: "object",
      get typeDef() { return (domain.types.EmailTemplate as ObjectType & { name: "EmailTemplate" }) },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    confirmationTextMessageId: {
      name: "confirmationTextMessageId",
      displayName: "Confirmation Text Message Id",
      type: "number",
      role: "value",
    },
    confirmationTextMessage: {
      name: "confirmationTextMessage",
      displayName: "Confirmation Text Message",
      type: "object",
      get typeDef() { return (domain.types.TextMessagingTemplate as ObjectType & { name: "TextMessagingTemplate" }) },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    cancellationEmailId: {
      name: "cancellationEmailId",
      displayName: "Cancellation Email Id",
      type: "number",
      role: "value",
    },
    cancellationEmail: {
      name: "cancellationEmail",
      displayName: "Cancellation Email",
      type: "object",
      get typeDef() { return (domain.types.EmailTemplate as ObjectType & { name: "EmailTemplate" }) },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    ticketReleaseEmailId: {
      name: "ticketReleaseEmailId",
      displayName: "Ticket Release Email Template",
      description: "Emailed to the customer when a purchase held by the tenant's ticket delivery delay becomes downloadable. Leave blank to use the tenant's default release template, or to send nothing when the tenant has none.",
      type: "number",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    ticketReleaseEmail: {
      name: "ticketReleaseEmail",
      displayName: "Ticket Release Email",
      type: "object",
      get typeDef() { return (domain.types.EmailTemplate as ObjectType & { name: "EmailTemplate" }) },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    venueId: {
      name: "venueId",
      displayName: "Venue Id",
      type: "number",
      role: "value",
    },
    venue: {
      name: "venue",
      displayName: "Venue",
      type: "object",
      get typeDef() { return (domain.types.Venue as ObjectType & { name: "Venue" }) },
      role: "value",
    },
    seatMapId: {
      name: "seatMapId",
      displayName: "Seat Map Id",
      type: "number",
      role: "value",
    },
    seatMap: {
      name: "seatMap",
      displayName: "Seat Map",
      type: "object",
      get typeDef() { return (domain.types.SeatMap as ObjectType & { name: "SeatMap" }) },
      role: "value",
    },
    hasPublishedSeries: {
      name: "hasPublishedSeries",
      displayName: "Has Published Series",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    eventSuggestedList: {
      name: "eventSuggestedList",
      displayName: "Event Suggested List",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventSuggestedEvent as ObjectType & { name: "EventSuggestedEvent" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    premiumRefundsEnabled: {
      name: "premiumRefundsEnabled",
      displayName: "Premium Refunds Enabled",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    refundableFeePercentage: {
      name: "refundableFeePercentage",
      displayName: "Refundable Fee Percentage",
      type: "number",
      role: "value",
      hidden: 3 as HiddenAreas,
      dontSerialize: true,
    },
    isTenantShowImageOnListView: {
      name: "isTenantShowImageOnListView",
      displayName: "Is Tenant Show Image On List View",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    isTenantAllowFreeEvent: {
      name: "isTenantAllowFreeEvent",
      displayName: "Is Tenant Allow Free Event",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    isTenantShowRemainingSeats: {
      name: "isTenantShowRemainingSeats",
      displayName: "Is Tenant Show Remaining Seats",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    hasFood: {
      name: "hasFood",
      displayName: "Has Food",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    seatSections: {
      name: "seatSections",
      displayName: "Seat Sections",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventSection as ObjectType & { name: "EventSection" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    eventDates: {
      name: "eventDates",
      displayName: "Event Dates",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventDate as ObjectType & { name: "EventDate" }) },
      },
      role: "value",
    },
    eventImages: {
      name: "eventImages",
      displayName: "Event Images",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventImage as ObjectType & { name: "EventImage" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    bannerImageSrc: {
      name: "bannerImageSrc",
      displayName: "Banner Image",
      type: "string",
      subtype: "url-image",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    gridViewImageSrc: {
      name: "gridViewImageSrc",
      displayName: "Grid View Background Image. Banner Image will be used instead if not set.",
      type: "string",
      subtype: "url-image",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    eventDiscountDefinitions: {
      name: "eventDiscountDefinitions",
      displayName: "Event Discount Definitions",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventDiscountDefinition as ObjectType & { name: "EventDiscountDefinition" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    eventEmailTemplates: {
      name: "eventEmailTemplates",
      displayName: "Event Email Templates",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventEmailTemplate as ObjectType & { name: "EventEmailTemplate" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    eventAddonItems: {
      name: "eventAddonItems",
      displayName: "Event Addon Items",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventAddonItemDefinition as ObjectType & { name: "EventAddonItemDefinition" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    eventPrices: {
      name: "eventPrices",
      displayName: "Event Prices",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventPrice as ObjectType & { name: "EventPrice" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    activeEventPrices: {
      name: "activeEventPrices",
      displayName: "Active Event Prices",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventPrice as ObjectType & { name: "EventPrice" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    absorbConvenienceFee: {
      name: "absorbConvenienceFee",
      displayName: "Absorb Convenience Fee",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    absorbTax: {
      name: "absorbTax",
      displayName: "Absorb Tax",
      description: "When enabled, sales tax will be waived at checkout and deducted from net revenue",
      type: "boolean",
      role: "value",
    },
    isFreeEvent: {
      name: "isFreeEvent",
      displayName: "Is Free Event",
      type: "boolean",
      role: "value",
    },
    requiresAccessCode: {
      name: "requiresAccessCode",
      displayName: "Requires Access Code",
      type: "boolean",
      role: "value",
    },
    accessCode: {
      name: "accessCode",
      displayName: "Access Code",
      type: "string",
      role: "value",
      hidden: 3 as HiddenAreas,
      rules: {
        minLength: val => !val || val.length >= 4 || "Access Code must be at least 4 characters.",
        maxLength: val => !val || val.length <= 20 || "Access Code may not be more than 20 characters.",
      }
    },
    notifyViaEmailWhenTicketPurchased: {
      name: "notifyViaEmailWhenTicketPurchased",
      displayName: "Purchase Email Notification",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventAddonDto = domain.types.EventAddonDto = {
  name: "EventAddonDto" as const,
  displayName: "Event Addon Dto",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    definitionId: {
      name: "definitionId",
      displayName: "Definition Id",
      type: "number",
      role: "value",
    },
    configurationId: {
      name: "configurationId",
      displayName: "Configuration Id",
      type: "number",
      role: "value",
    },
    name: {
      name: "name",
      displayName: "Name",
      type: "string",
      role: "value",
    },
    description: {
      name: "description",
      displayName: "Description",
      type: "string",
      role: "value",
    },
    price: {
      name: "price",
      displayName: "Price",
      type: "number",
      role: "value",
    },
    priceDescription: {
      name: "priceDescription",
      displayName: "Price Description",
      type: "string",
      role: "value",
    },
    hasQuantity: {
      name: "hasQuantity",
      displayName: "Has Quantity",
      type: "boolean",
      role: "value",
    },
  },
}
export const EventAddonItemDefinition = domain.types.EventAddonItemDefinition = {
  name: "EventAddonItemDefinition" as const,
  displayName: "Event Addon Item Definition",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventId: {
      name: "eventId",
      displayName: "Event Id",
      type: "number",
      role: "value",
    },
    addonItemDefinitionId: {
      name: "addonItemDefinitionId",
      displayName: "Addon Item Definition Id",
      type: "number",
      role: "value",
    },
    addonItemDefinition: {
      name: "addonItemDefinition",
      displayName: "Addon Item Definition",
      type: "object",
      get typeDef() { return (domain.types.AddonItemDefinition as ObjectType & { name: "AddonItemDefinition" }) },
      role: "value",
    },
    event: {
      name: "event",
      displayName: "Event",
      type: "object",
      get typeDef() { return (domain.types.Event as ObjectType & { name: "Event" }) },
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventDate = domain.types.EventDate = {
  name: "EventDate" as const,
  displayName: "Event Date",
  get displayProp() { return this.props.listDisplayText }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventStartDateTime: {
      name: "eventStartDateTime",
      displayName: "Event Start Date Time",
      type: "date",
      dateKind: "datetime",
      role: "value",
      rules: {
        required: val => val != null || "Event Start Date Time is required.",
      }
    },
    eventEndDateTime: {
      name: "eventEndDateTime",
      displayName: "Event End Date Time",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
    durationMinutes: {
      name: "durationMinutes",
      displayName: "Duration Minutes",
      type: "number",
      role: "value",
    },
    eventPublicPurchaseDatetime: {
      name: "eventPublicPurchaseDatetime",
      displayName: "Event Public Purchase Datetime",
      type: "date",
      dateKind: "datetime",
      role: "value",
    },
    eventCapacity: {
      name: "eventCapacity",
      displayName: "Event Capacity",
      type: "number",
      role: "value",
      rules: {
        required: val => val != null || "Event Capacity is required.",
        min: val => val == null || val >= 0 || "Event Capacity must be at least 0.",
      }
    },
    cancelled: {
      name: "cancelled",
      displayName: "Cancelled",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    hiddenFromInitialPurchase: {
      name: "hiddenFromInitialPurchase",
      displayName: "Hidden From Initial Purchase",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    eventId: {
      name: "eventId",
      displayName: "Event Id",
      type: "number",
      role: "value",
    },
    event: {
      name: "event",
      displayName: "Event",
      type: "object",
      get typeDef() { return (domain.types.Event as ObjectType & { name: "Event" }) },
      role: "value",
    },
    eventSeriesId: {
      name: "eventSeriesId",
      displayName: "Event Series Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    eventSeries: {
      name: "eventSeries",
      displayName: "Event Series",
      type: "object",
      get typeDef() { return (domain.types.EventSeries as ObjectType & { name: "EventSeries" }) },
      role: "value",
    },
    eventDateDiscountDefinitions: {
      name: "eventDateDiscountDefinitions",
      displayName: "Event Date Discount Definitions",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventDateDiscountDefinition as ObjectType & { name: "EventDateDiscountDefinition" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    seatRestrictions: {
      name: "seatRestrictions",
      displayName: "Seat Restrictions",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventDateSeatRestriction as ObjectType & { name: "EventDateSeatRestriction" }) },
      },
      role: "value",
    },
    priceConfigurations: {
      name: "priceConfigurations",
      displayName: "Price Configurations",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventDatePriceConfig as ObjectType & { name: "EventDatePriceConfig" }) },
      },
      role: "value",
    },
    customMoreOptionsUrl: {
      name: "customMoreOptionsUrl",
      displayName: "Custom More Options Url",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    customSelectTicketsUrl: {
      name: "customSelectTicketsUrl",
      displayName: "Custom Select Tickets Url",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    customMoreOptionsButtonText: {
      name: "customMoreOptionsButtonText",
      displayName: "Custom More Options Button Text",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    customSelectTicketsButtonText: {
      name: "customSelectTicketsButtonText",
      displayName: "Custom More Options Button Text",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    customMoreOptionsIcon: {
      name: "customMoreOptionsIcon",
      displayName: "Custom More Options Icon",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    customSelectTicketsIcon: {
      name: "customSelectTicketsIcon",
      displayName: "Custom Select Tickets Icon",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    availableSeats: {
      name: "availableSeats",
      displayName: "Available Seats",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    availableSeatsCacheDate: {
      name: "availableSeatsCacheDate",
      displayName: "Available Seats Cache Date",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
    listDisplayText: {
      name: "listDisplayText",
      displayName: "List Display Text",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventDateDiscountDefinition = domain.types.EventDateDiscountDefinition = {
  name: "EventDateDiscountDefinition" as const,
  displayName: "Event Date Discount Definition",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventDateId: {
      name: "eventDateId",
      displayName: "Event Date Id",
      type: "number",
      role: "value",
    },
    discountDefinitionId: {
      name: "discountDefinitionId",
      displayName: "Discount Definition Id",
      type: "number",
      role: "value",
    },
    discountDefinition: {
      name: "discountDefinition",
      displayName: "Discount Definition",
      type: "object",
      get typeDef() { return (domain.types.DiscountDefinition as ObjectType & { name: "DiscountDefinition" }) },
      role: "value",
    },
    eventDate: {
      name: "eventDate",
      displayName: "Event Date",
      type: "object",
      get typeDef() { return (domain.types.EventDate as ObjectType & { name: "EventDate" }) },
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventDatePriceConfig = domain.types.EventDatePriceConfig = {
  name: "EventDatePriceConfig" as const,
  displayName: "Event Date Price Config",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventDateId: {
      name: "eventDateId",
      displayName: "Event Date Id",
      type: "number",
      role: "value",
    },
    eventDate: {
      name: "eventDate",
      displayName: "Event Date",
      type: "object",
      get typeDef() { return (domain.types.EventDate as ObjectType & { name: "EventDate" }) },
      role: "value",
    },
    eventPriceRootId: {
      name: "eventPriceRootId",
      displayName: "Event Price Root Id",
      type: "number",
      role: "value",
    },
    maxQuantity: {
      name: "maxQuantity",
      displayName: "Max Quantity",
      type: "number",
      role: "value",
    },
    availableTickets: {
      name: "availableTickets",
      displayName: "Available Tickets",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventDateSeatingInfo = domain.types.EventDateSeatingInfo = {
  name: "EventDateSeatingInfo" as const,
  displayName: "Event Date Seating Info",
  type: "object",
  props: {
    eventDateId: {
      name: "eventDateId",
      displayName: "Event Date Id",
      type: "number",
      role: "value",
    },
    seatMap: {
      name: "seatMap",
      displayName: "Seat Map",
      type: "object",
      get typeDef() { return (domain.types.SeatMapDto as ObjectType & { name: "SeatMapDto" }) },
      role: "value",
    },
    availableSeats: {
      name: "availableSeats",
      displayName: "Available Seats",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "string",
      },
      role: "value",
    },
    availableSeatsDetails: {
      name: "availableSeatsDetails",
      displayName: "Available Seats Details",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.AvailableSeatsDetails as ObjectType & { name: "AvailableSeatsDetails" }) },
      },
      role: "value",
    },
    totalAmountOfAvailableSeats: {
      name: "totalAmountOfAvailableSeats",
      displayName: "Total Amount Of Available Seats",
      type: "number",
      role: "value",
    },
    availableSeatsBySection: {
      name: "availableSeatsBySection",
      displayName: "Available Seats By Section",
      // Type not supported natively by Coalesce - falling back to unknown.
      type: "unknown",
      role: "value",
    },
    restrictions: {
      name: "restrictions",
      displayName: "Restrictions",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventDateSeatingRestrictionInfo as ObjectType & { name: "EventDateSeatingRestrictionInfo" }) },
      },
      role: "value",
    },
    seatLabels: {
      name: "seatLabels",
      displayName: "Seat Labels",
      // Type not supported natively by Coalesce - falling back to unknown.
      type: "unknown",
      role: "value",
    },
    availableTicketsByPrice: {
      name: "availableTicketsByPrice",
      displayName: "Available Tickets By Price",
      // Type not supported natively by Coalesce - falling back to unknown.
      type: "unknown",
      role: "value",
    },
    takenSeatPurchaserNames: {
      name: "takenSeatPurchaserNames",
      displayName: "Taken Seat Purchaser Names",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.TakenSeatPurchaserName as ObjectType & { name: "TakenSeatPurchaserName" }) },
      },
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventDateSeatingRestrictionInfo = domain.types.EventDateSeatingRestrictionInfo = {
  name: "EventDateSeatingRestrictionInfo" as const,
  displayName: "Event Date Seating Restriction Info",
  type: "object",
  props: {
    seats: {
      name: "seats",
      displayName: "Seats",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "string",
      },
      role: "value",
    },
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    agentOnly: {
      name: "agentOnly",
      displayName: "Agent Only",
      type: "boolean",
      role: "value",
    },
    agentNote: {
      name: "agentNote",
      displayName: "Agent Note",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventDateSeatRestriction = domain.types.EventDateSeatRestriction = {
  name: "EventDateSeatRestriction" as const,
  displayName: "Event Date Seat Restriction",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventDateId: {
      name: "eventDateId",
      displayName: "Event Date Id",
      type: "number",
      role: "value",
    },
    eventDate: {
      name: "eventDate",
      displayName: "Event Date",
      type: "object",
      get typeDef() { return (domain.types.EventDate as ObjectType & { name: "EventDate" }) },
      role: "value",
    },
    agentOnly: {
      name: "agentOnly",
      displayName: "Agent Only",
      type: "boolean",
      role: "value",
    },
    agentNote: {
      name: "agentNote",
      displayName: "Agent Note",
      type: "string",
      role: "value",
    },
    seatNumbersJson: {
      name: "seatNumbersJson",
      displayName: "Seat Numbers Json",
      type: "string",
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventDiscountDefinition = domain.types.EventDiscountDefinition = {
  name: "EventDiscountDefinition" as const,
  displayName: "Event Discount Definition",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventId: {
      name: "eventId",
      displayName: "Event Id",
      type: "number",
      role: "value",
    },
    discountDefinitionId: {
      name: "discountDefinitionId",
      displayName: "Discount Definition Id",
      type: "number",
      role: "value",
    },
    discountDefinition: {
      name: "discountDefinition",
      displayName: "Discount Definition",
      type: "object",
      get typeDef() { return (domain.types.DiscountDefinition as ObjectType & { name: "DiscountDefinition" }) },
      role: "value",
    },
    event: {
      name: "event",
      displayName: "Event",
      type: "object",
      get typeDef() { return (domain.types.Event as ObjectType & { name: "Event" }) },
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventEmailTemplate = domain.types.EventEmailTemplate = {
  name: "EventEmailTemplate" as const,
  displayName: "Event Email Template",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventId: {
      name: "eventId",
      displayName: "Event Id",
      type: "number",
      role: "value",
    },
    emailTemplateId: {
      name: "emailTemplateId",
      displayName: "Email Template Id",
      type: "number",
      role: "value",
    },
    emailTemplate: {
      name: "emailTemplate",
      displayName: "Email Template",
      type: "object",
      get typeDef() { return (domain.types.EmailTemplate as ObjectType & { name: "EmailTemplate" }) },
      role: "value",
    },
    event: {
      name: "event",
      displayName: "Event",
      type: "object",
      get typeDef() { return (domain.types.Event as ObjectType & { name: "Event" }) },
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventImage = domain.types.EventImage = {
  name: "EventImage" as const,
  displayName: "Event Image",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventId: {
      name: "eventId",
      displayName: "Event Id",
      type: "number",
      role: "value",
      rules: {
        required: val => val != null || "Event Id is required.",
      }
    },
    imageSrc: {
      name: "imageSrc",
      displayName: "Image Src",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Image Src is required.",
      }
    },
    altText: {
      name: "altText",
      displayName: "Alt Text",
      type: "string",
      role: "value",
    },
    order: {
      name: "order",
      displayName: "Order",
      type: "number",
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventImageDto = domain.types.EventImageDto = {
  name: "EventImageDto" as const,
  displayName: "Event Image Dto",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventId: {
      name: "eventId",
      displayName: "Event Id",
      type: "number",
      role: "value",
      rules: {
        required: val => val != null || "Event Id is required.",
      }
    },
    imageSrc: {
      name: "imageSrc",
      displayName: "Image Src",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Image Src is required.",
      }
    },
    altText: {
      name: "altText",
      displayName: "Alt Text",
      type: "string",
      role: "value",
    },
    order: {
      name: "order",
      displayName: "Order",
      type: "number",
      role: "value",
    },
  },
}
export const EventPrice = domain.types.EventPrice = {
  name: "EventPrice" as const,
  displayName: "Event Price",
  get displayProp() { return this.props.displayName }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    rootId: {
      name: "rootId",
      displayName: "Root Id",
      type: "number",
      role: "value",
    },
    eventId: {
      name: "eventId",
      displayName: "Event Id",
      type: "number",
      role: "value",
    },
    event: {
      name: "event",
      displayName: "Event",
      type: "object",
      get typeDef() { return (domain.types.Event as ObjectType & { name: "Event" }) },
      role: "value",
    },
    activeEventId: {
      name: "activeEventId",
      displayName: "Active Event Id",
      type: "number",
      role: "value",
    },
    activeEvent: {
      name: "activeEvent",
      displayName: "Active Event",
      type: "object",
      get typeDef() { return (domain.types.Event as ObjectType & { name: "Event" }) },
      role: "value",
    },
    ticketTypeId: {
      name: "ticketTypeId",
      displayName: "Ticket Type Id",
      type: "number",
      role: "value",
    },
    ticketType: {
      name: "ticketType",
      displayName: "Ticket Type",
      type: "object",
      get typeDef() { return (domain.types.TicketType as ObjectType & { name: "TicketType" }) },
      role: "value",
    },
    order: {
      name: "order",
      displayName: "Order",
      type: "number",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    displayName: {
      name: "displayName",
      displayName: "Display Name",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Display Name is required.",
        maxLength: val => !val || val.length <= 100 || "Display Name may not be more than 100 characters.",
      }
    },
    details: {
      name: "details",
      displayName: "Details",
      type: "string",
      role: "value",
      rules: {
        maxLength: val => !val || val.length <= 100 || "Details may not be more than 100 characters.",
      }
    },
    price: {
      name: "price",
      displayName: "Price",
      type: "number",
      role: "value",
    },
    serviceFee: {
      name: "serviceFee",
      displayName: "Service Fee",
      type: "number",
      role: "value",
    },
    agentServiceFee: {
      name: "agentServiceFee",
      displayName: "Agent Service Fee",
      type: "number",
      role: "value",
    },
    onlyAgent: {
      name: "onlyAgent",
      displayName: "Only Agent",
      type: "boolean",
      role: "value",
      defaultValue: false,
    },
    currentServiceFeeFromTenant: {
      name: "currentServiceFeeFromTenant",
      displayName: "Current Service Fee From Tenant",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    currentAgentServiceFeeFromTenant: {
      name: "currentAgentServiceFeeFromTenant",
      displayName: "Current Agent Service Fee From Tenant",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    isServiceFeeOverridden: {
      name: "isServiceFeeOverridden",
      displayName: "Is Service Fee Overridden",
      type: "boolean",
      role: "value",
      defaultValue: false,
    },
    tenantIsAllowOverrideServiceFee: {
      name: "tenantIsAllowOverrideServiceFee",
      displayName: "Tenant Is Allow Override Service Fee",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    tenantDefaultServiceFee: {
      name: "tenantDefaultServiceFee",
      displayName: "Tenant Default Service Fee",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    tenantDefaultAgentServiceFee: {
      name: "tenantDefaultAgentServiceFee",
      displayName: "Tenant Default Agent Service Fee",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    revenueDistributions: {
      name: "revenueDistributions",
      displayName: "Revenue Distributions",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventPriceRevenueDistribution as ObjectType & { name: "EventPriceRevenueDistribution" }) },
      },
      role: "value",
    },
    seats: {
      name: "seats",
      displayName: "Seats",
      type: "number",
      role: "value",
      rules: {
        min: val => val == null || val >= 0 || "Seats must be at least 0.",
      }
    },
    defaultMaxQuantity: {
      name: "defaultMaxQuantity",
      displayName: "Default Max Quantity",
      type: "number",
      role: "value",
    },
    minimumQuantity: {
      name: "minimumQuantity",
      displayName: "Minimum Quantity",
      type: "number",
      role: "value",
    },
    maximumPurchaseQuantity: {
      name: "maximumPurchaseQuantity",
      displayName: "Maximum Ticket Purchase",
      type: "number",
      role: "value",
      defaultValue: 0,
    },
    isComp: {
      name: "isComp",
      displayName: "Is Comp Ticket Price",
      type: "boolean",
      role: "value",
      defaultValue: false,
    },
    isFree: {
      name: "isFree",
      displayName: "Is Free Ticket Type",
      type: "boolean",
      role: "value",
      defaultValue: false,
    },
    lowInventoryThreshold: {
      name: "lowInventoryThreshold",
      displayName: "Low Inventory Alert Threshold",
      type: "number",
      role: "value",
      defaultValue: 0,
      rules: {
        min: val => val == null || val >= 0 || "Low Inventory Alert Threshold must be at least 0.",
      }
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventPriceDto = domain.types.EventPriceDto = {
  name: "EventPriceDto" as const,
  displayName: "Event Price Dto",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    rootId: {
      name: "rootId",
      displayName: "Root Id",
      type: "number",
      role: "value",
    },
    displayName: {
      name: "displayName",
      displayName: "Display Name",
      type: "string",
      role: "value",
    },
    description: {
      name: "description",
      displayName: "Description",
      type: "string",
      role: "value",
    },
    price: {
      name: "price",
      displayName: "Price",
      type: "number",
      role: "value",
    },
    order: {
      name: "order",
      displayName: "Order",
      type: "number",
      role: "value",
    },
    serviceFee: {
      name: "serviceFee",
      displayName: "Service Fee",
      type: "number",
      role: "value",
    },
    agentServiceFee: {
      name: "agentServiceFee",
      displayName: "Agent Service Fee",
      type: "number",
      role: "value",
    },
    seats: {
      name: "seats",
      displayName: "Seats",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    minimumQuantity: {
      name: "minimumQuantity",
      displayName: "Minimum Quantity",
      type: "number",
      role: "value",
    },
    maximumPurchaseQuantity: {
      name: "maximumPurchaseQuantity",
      displayName: "Maximum Purchase Quantity",
      type: "number",
      role: "value",
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Last Change Date",
      type: "date",
      dateKind: "datetime",
      role: "value",
    },
    tenantIsAllowOverrideServiceFee: {
      name: "tenantIsAllowOverrideServiceFee",
      displayName: "Tenant Is Allow Override Service Fee",
      type: "boolean",
      role: "value",
    },
    isServiceFeeOverridden: {
      name: "isServiceFeeOverridden",
      displayName: "Is Service Fee Overridden",
      type: "boolean",
      role: "value",
    },
    tenantDefaultServiceFee: {
      name: "tenantDefaultServiceFee",
      displayName: "Tenant Default Service Fee",
      type: "number",
      role: "value",
    },
    tenantDefaultAgentServiceFee: {
      name: "tenantDefaultAgentServiceFee",
      displayName: "Tenant Default Agent Service Fee",
      type: "number",
      role: "value",
    },
    isSoldOut: {
      name: "isSoldOut",
      displayName: "Is Sold Out",
      type: "boolean",
      role: "value",
    },
    lowInventoryThreshold: {
      name: "lowInventoryThreshold",
      displayName: "Low Inventory Threshold",
      type: "number",
      role: "value",
    },
    isComp: {
      name: "isComp",
      displayName: "Is Comp",
      type: "boolean",
      role: "value",
    },
    isFree: {
      name: "isFree",
      displayName: "Is Free",
      type: "boolean",
      role: "value",
    },
    ticketTypeId: {
      name: "ticketTypeId",
      displayName: "Ticket Type Id",
      type: "number",
      role: "value",
    },
    seatMapSectionId: {
      name: "seatMapSectionId",
      displayName: "Seat Map Section Id",
      type: "number",
      role: "value",
    },
    availableTickets: {
      name: "availableTickets",
      displayName: "Available Tickets",
      type: "number",
      role: "value",
    },
    convenienceFeeAmount: {
      name: "convenienceFeeAmount",
      displayName: "Convenience Fee Amount",
      type: "number",
      role: "value",
    },
    salesTaxAmount: {
      name: "salesTaxAmount",
      displayName: "Sales Tax Amount",
      type: "number",
      role: "value",
    },
    totalSingle: {
      name: "totalSingle",
      displayName: "Total Single",
      type: "number",
      role: "value",
    },
  },
}
export const EventPriceRevenueDistribution = domain.types.EventPriceRevenueDistribution = {
  name: "EventPriceRevenueDistribution" as const,
  displayName: "Event Price Revenue Distribution",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventPriceId: {
      name: "eventPriceId",
      displayName: "Event Price Id",
      type: "number",
      role: "value",
    },
    eventPrice: {
      name: "eventPrice",
      displayName: "Event Price",
      type: "object",
      get typeDef() { return (domain.types.EventPrice as ObjectType & { name: "EventPrice" }) },
      role: "value",
    },
    revenueCategoryId: {
      name: "revenueCategoryId",
      displayName: "Revenue Category Id",
      type: "number",
      role: "value",
    },
    revenueCategory: {
      name: "revenueCategory",
      displayName: "Revenue Category",
      type: "object",
      get typeDef() { return (domain.types.RevenueCategory as ObjectType & { name: "RevenueCategory" }) },
      role: "value",
    },
    revenue: {
      name: "revenue",
      displayName: "Revenue",
      type: "number",
      role: "value",
    },
  },
}
export const EventSection = domain.types.EventSection = {
  name: "EventSection" as const,
  displayName: "Event Section",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventId: {
      name: "eventId",
      displayName: "Event Id",
      type: "number",
      role: "value",
    },
    event: {
      name: "event",
      displayName: "Event",
      type: "object",
      get typeDef() { return (domain.types.Event as ObjectType & { name: "Event" }) },
      role: "value",
    },
    seatMapSectionId: {
      name: "seatMapSectionId",
      displayName: "Seat Map Section Id",
      type: "number",
      role: "value",
    },
    seatMapSection: {
      name: "seatMapSection",
      displayName: "Seat Map Section",
      type: "object",
      get typeDef() { return (domain.types.SeatMapSection as ObjectType & { name: "SeatMapSection" }) },
      role: "value",
    },
    sjVmtColor: {
      name: "sjVmtColor",
      displayName: "Sj Vmt Color",
      type: "string",
      role: "value",
    },
    isEnabled: {
      name: "isEnabled",
      displayName: "Is Enabled",
      type: "boolean",
      role: "value",
    },
    prices: {
      name: "prices",
      displayName: "Prices",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventSectionPrice as ObjectType & { name: "EventSectionPrice" }) },
      },
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventSectionPrice = domain.types.EventSectionPrice = {
  name: "EventSectionPrice" as const,
  displayName: "Event Section Price",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventSectionId: {
      name: "eventSectionId",
      displayName: "Event Section Id",
      type: "number",
      role: "value",
    },
    eventSection: {
      name: "eventSection",
      displayName: "Event Section",
      type: "object",
      get typeDef() { return (domain.types.EventSection as ObjectType & { name: "EventSection" }) },
      role: "value",
    },
    eventPriceId: {
      name: "eventPriceId",
      displayName: "Event Price Id",
      type: "number",
      role: "value",
    },
    eventPrice: {
      name: "eventPrice",
      displayName: "Event Price",
      type: "object",
      get typeDef() { return (domain.types.EventPrice as ObjectType & { name: "EventPrice" }) },
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventSeries = domain.types.EventSeries = {
  name: "EventSeries" as const,
  displayName: "Event Series",
  get displayProp() { return this.props.displayName }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventId: {
      name: "eventId",
      displayName: "Event Id",
      type: "number",
      role: "value",
      rules: {
        required: val => val != null || "Event Id is required.",
      }
    },
    event: {
      name: "event",
      displayName: "Event",
      type: "object",
      get typeDef() { return (domain.types.Event as ObjectType & { name: "Event" }) },
      role: "value",
    },
    displayName: {
      name: "displayName",
      displayName: "Display Name",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    startDate: {
      name: "startDate",
      displayName: "Start Date",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
    endDate: {
      name: "endDate",
      displayName: "End Date",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
    status: {
      name: "status",
      displayName: "Status",
      type: "enum",
      get typeDef() { return EventSeriesStatus },
      role: "value",
    },
    passTypes: {
      name: "passTypes",
      displayName: "Pass Types",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.PassType as ObjectType & { name: "PassType" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    eventDates: {
      name: "eventDates",
      displayName: "Event Dates",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventDate as ObjectType & { name: "EventDate" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventSuggestedEvent = domain.types.EventSuggestedEvent = {
  name: "EventSuggestedEvent" as const,
  displayName: "Event Suggested Event",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventId: {
      name: "eventId",
      displayName: "Event Id",
      type: "number",
      role: "value",
    },
    event: {
      name: "event",
      displayName: "Event",
      type: "object",
      get typeDef() { return (domain.types.Event as ObjectType & { name: "Event" }) },
      role: "value",
    },
    suggestedEventId: {
      name: "suggestedEventId",
      displayName: "Suggested Event Id",
      type: "number",
      role: "value",
    },
    suggestedEvent: {
      name: "suggestedEvent",
      displayName: "Suggested Event",
      type: "object",
      get typeDef() { return (domain.types.Event as ObjectType & { name: "Event" }) },
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const EventType = domain.types.EventType = {
  name: "EventType" as const,
  displayName: "Event Type",
  get displayProp() { return this.props.shortDescription }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    shortDescription: {
      name: "shortDescription",
      displayName: "Short Description",
      description: "Shown to users in the Event Type filters on the calendar + list views.",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Short Description is required.",
      }
    },
    longDescription: {
      name: "longDescription",
      displayName: "Long Description",
      description: "This field is currently not shown anywhere in the app.",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Long Description is required.",
      }
    },
    refundPolicy: {
      name: "refundPolicy",
      displayName: "Refund Policy",
      description: "A description of the refund policy for Events of this type to be displayed to users alongside the refunds option (if enabled for the Event) during the checkout process.",
      type: "string",
      subtype: "multiline",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    events: {
      name: "events",
      displayName: "Events",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.Event as ObjectType & { name: "Event" }) },
      },
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const PassType = domain.types.PassType = {
  name: "PassType" as const,
  displayName: "Pass Type",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventSeriesId: {
      name: "eventSeriesId",
      displayName: "Event Series Id",
      type: "number",
      role: "value",
      rules: {
        required: val => val != null || "Event Series Id is required.",
      }
    },
    eventSeries: {
      name: "eventSeries",
      displayName: "Event Series",
      type: "object",
      get typeDef() { return (domain.types.EventSeries as ObjectType & { name: "EventSeries" }) },
      role: "value",
    },
    eventPriceId: {
      name: "eventPriceId",
      displayName: "Event Price Id",
      type: "number",
      role: "value",
      rules: {
        required: val => val != null || "Event Price Id is required.",
      }
    },
    eventPrice: {
      name: "eventPrice",
      displayName: "Event Price",
      type: "object",
      get typeDef() { return (domain.types.EventPrice as ObjectType & { name: "EventPrice" }) },
      role: "value",
    },
    name: {
      name: "name",
      displayName: "Name",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Name is required.",
      }
    },
    passCategory: {
      name: "passCategory",
      displayName: "Pass Category",
      type: "enum",
      get typeDef() { return PassCategory },
      role: "value",
      rules: {
        required: val => val != null || "Pass Category is required.",
      }
    },
    order: {
      name: "order",
      displayName: "Order",
      type: "number",
      role: "value",
    },
    maxQuantityPerPurchase: {
      name: "maxQuantityPerPurchase",
      displayName: "Max Quantity Per Purchase",
      type: "number",
      role: "value",
    },
    isActive: {
      name: "isActive",
      displayName: "Is Active",
      type: "boolean",
      role: "value",
    },
    passTypeDates: {
      name: "passTypeDates",
      displayName: "Pass Type Dates",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.PassTypeDate as ObjectType & { name: "PassTypeDate" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const PassTypeDate = domain.types.PassTypeDate = {
  name: "PassTypeDate" as const,
  displayName: "Pass Type Date",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    passTypeId: {
      name: "passTypeId",
      displayName: "Pass Type Id",
      type: "number",
      role: "value",
      rules: {
        required: val => val != null || "Pass Type Id is required.",
      }
    },
    passType: {
      name: "passType",
      displayName: "Pass Type",
      type: "object",
      get typeDef() { return (domain.types.PassType as ObjectType & { name: "PassType" }) },
      role: "value",
    },
    eventDateId: {
      name: "eventDateId",
      displayName: "Event Date Id",
      type: "number",
      role: "value",
      rules: {
        required: val => val != null || "Event Date Id is required.",
      }
    },
    eventDate: {
      name: "eventDate",
      displayName: "Event Date",
      type: "object",
      get typeDef() { return (domain.types.EventDate as ObjectType & { name: "EventDate" }) },
      role: "value",
    },
    availableTickets: {
      name: "availableTickets",
      displayName: "Available Tickets",
      type: "number",
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const PaymentGateway = domain.types.PaymentGateway = {
  name: "PaymentGateway" as const,
  displayName: "Payment Gateway",
  get displayProp() { return this.props.displayName }, 
  type: "object",
  props: {
    paymentGatewayId: {
      name: "paymentGatewayId",
      displayName: "Payment Gateway Id",
      type: "number",
      role: "value",
    },
    displayName: {
      name: "displayName",
      displayName: "Display Name",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Display Name is required.",
      }
    },
    prependShortCodeToInvoice: {
      name: "prependShortCodeToInvoice",
      displayName: "Prepend Short Code To Invoice",
      type: "boolean",
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const PostalCodeInfo = domain.types.PostalCodeInfo = {
  name: "PostalCodeInfo" as const,
  displayName: "Postal Code Info",
  type: "object",
  props: {
    country: {
      name: "country",
      displayName: "Country",
      type: "string",
      role: "value",
    },
    zip: {
      name: "zip",
      displayName: "Zip",
      type: "string",
      role: "value",
    },
    city: {
      name: "city",
      displayName: "City",
      type: "string",
      role: "value",
    },
    state: {
      name: "state",
      displayName: "State",
      type: "string",
      role: "value",
    },
    stateAbbr: {
      name: "stateAbbr",
      displayName: "State Abbr",
      type: "string",
      role: "value",
    },
  },
}
export const PublicBannerAlertDto = domain.types.PublicBannerAlertDto = {
  name: "PublicBannerAlertDto" as const,
  displayName: "Public Banner Alert Dto",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    message: {
      name: "message",
      displayName: "Message",
      type: "string",
      role: "value",
    },
    color: {
      name: "color",
      displayName: "Color",
      type: "string",
      role: "value",
    },
  },
}
export const PublicSeriesDto = domain.types.PublicSeriesDto = {
  name: "PublicSeriesDto" as const,
  displayName: "Public Series Dto",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    eventName: {
      name: "eventName",
      displayName: "Event Name",
      type: "string",
      role: "value",
    },
    shortDescription: {
      name: "shortDescription",
      displayName: "Short Description",
      type: "string",
      role: "value",
    },
    longDescription: {
      name: "longDescription",
      displayName: "Long Description",
      type: "string",
      role: "value",
    },
    location: {
      name: "location",
      displayName: "Location",
      type: "string",
      role: "value",
    },
    bannerImageSrc: {
      name: "bannerImageSrc",
      displayName: "Banner Image Src",
      type: "string",
      role: "value",
    },
    startDate: {
      name: "startDate",
      displayName: "Start Date",
      type: "date",
      dateKind: "datetime",
      role: "value",
    },
    endDate: {
      name: "endDate",
      displayName: "End Date",
      type: "date",
      dateKind: "datetime",
      role: "value",
    },
    passTypes: {
      name: "passTypes",
      displayName: "Pass Types",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.PublicSeriesPassTypeDto as ObjectType & { name: "PublicSeriesPassTypeDto" }) },
      },
      role: "value",
    },
  },
}
export const PublicSeriesPassTypeDto = domain.types.PublicSeriesPassTypeDto = {
  name: "PublicSeriesPassTypeDto" as const,
  displayName: "Public Series Pass Type Dto",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    name: {
      name: "name",
      displayName: "Name",
      type: "string",
      role: "value",
    },
    passCategory: {
      name: "passCategory",
      displayName: "Pass Category",
      type: "enum",
      get typeDef() { return PassCategory },
      role: "value",
    },
    order: {
      name: "order",
      displayName: "Order",
      type: "number",
      role: "value",
    },
    price: {
      name: "price",
      displayName: "Price",
      type: "number",
      role: "value",
    },
    serviceFee: {
      name: "serviceFee",
      displayName: "Service Fee",
      type: "number",
      role: "value",
    },
    dates: {
      name: "dates",
      displayName: "Dates",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "date",
        dateKind: "datetime",
      },
      role: "value",
    },
  },
}
export const PublicSystemAlertDto = domain.types.PublicSystemAlertDto = {
  name: "PublicSystemAlertDto" as const,
  displayName: "Public System Alert Dto",
  type: "object",
  props: {
    systemAlertId: {
      name: "systemAlertId",
      displayName: "System Alert Id",
      type: "number",
      role: "value",
    },
    message: {
      name: "message",
      displayName: "Message",
      type: "string",
      role: "value",
    },
    severity: {
      name: "severity",
      displayName: "Severity",
      type: "enum",
      get typeDef() { return AlertSeverity },
      role: "value",
    },
  },
}
export const RefundOverrideLog = domain.types.RefundOverrideLog = {
  name: "RefundOverrideLog" as const,
  displayName: "Refund Override Log",
  get displayProp() { return this.props.overrideNote }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    ticketPurchaseId: {
      name: "ticketPurchaseId",
      displayName: "Ticket Purchase Id",
      type: "number",
      role: "value",
    },
    ticketPurchase: {
      name: "ticketPurchase",
      displayName: "Ticket Purchase",
      type: "object",
      get typeDef() { return (domain.types.TicketPurchase as ObjectType & { name: "TicketPurchase" }) },
      role: "value",
    },
    tenantId: {
      name: "tenantId",
      displayName: "Tenant Id",
      type: "number",
      role: "value",
    },
    userName: {
      name: "userName",
      displayName: "User Name",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "User Name is required.",
      }
    },
    date: {
      name: "date",
      displayName: "Date",
      type: "date",
      dateKind: "datetime",
      role: "value",
    },
    overrideNote: {
      name: "overrideNote",
      displayName: "Override Note",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Override Note is required.",
      }
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const RevenueCategory = domain.types.RevenueCategory = {
  name: "RevenueCategory" as const,
  displayName: "Revenue Category",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    name: {
      name: "name",
      displayName: "Name",
      description: "Name used in report headings, recorded immutably in the app's transaction log.",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Name is required.",
        maxLength: val => !val || val.length <= 50 || "Name may not be more than 50 characters.",
      }
    },
    description: {
      name: "description",
      displayName: "Description",
      description: "Explanation of the purpose of this category.",
      type: "string",
      role: "value",
    },
    order: {
      name: "order",
      displayName: "Order",
      description: "The order of this category in reports.",
      type: "number",
      role: "value",
    },
    isArchived: {
      name: "isArchived",
      displayName: "Is Archived",
      type: "boolean",
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const SeatMap = domain.types.SeatMap = {
  name: "SeatMap" as const,
  displayName: "Seat Map",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    venueId: {
      name: "venueId",
      displayName: "Venue Id",
      type: "number",
      role: "value",
    },
    venue: {
      name: "venue",
      displayName: "Venue",
      type: "object",
      get typeDef() { return (domain.types.Venue as ObjectType & { name: "Venue" }) },
      role: "value",
    },
    name: {
      name: "name",
      displayName: "Name",
      type: "string",
      role: "value",
    },
    method: {
      name: "method",
      displayName: "Seat Map Method",
      type: "enum",
      get typeDef() { return SeatMapMethodEnum },
      role: "value",
      hidden: 2 as HiddenAreas,
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const SeatMapAnnotationDto = domain.types.SeatMapAnnotationDto = {
  name: "SeatMapAnnotationDto" as const,
  displayName: "Seat Map Annotation Dto",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    x: {
      name: "x",
      displayName: "X",
      type: "number",
      role: "value",
    },
    y: {
      name: "y",
      displayName: "Y",
      type: "number",
      role: "value",
    },
    width: {
      name: "width",
      displayName: "Width",
      type: "number",
      role: "value",
    },
    height: {
      name: "height",
      displayName: "Height",
      type: "number",
      role: "value",
    },
    label: {
      name: "label",
      displayName: "Label",
      type: "string",
      role: "value",
    },
    fontScale: {
      name: "fontScale",
      displayName: "Font Scale",
      type: "number",
      role: "value",
    },
    shape: {
      name: "shape",
      displayName: "Shape",
      type: "enum",
      get typeDef() { return SeatMapAnnotationShape },
      role: "value",
    },
  },
}
export const SeatMapDto = domain.types.SeatMapDto = {
  name: "SeatMapDto" as const,
  displayName: "Seat Map Dto",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    name: {
      name: "name",
      displayName: "Name",
      type: "string",
      role: "value",
    },
    venueId: {
      name: "venueId",
      displayName: "Venue Id",
      type: "number",
      role: "value",
    },
    venueName: {
      name: "venueName",
      displayName: "Venue Name",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    method: {
      name: "method",
      displayName: "Method",
      type: "enum",
      get typeDef() { return SeatMapMethodEnum },
      role: "value",
    },
    sections: {
      name: "sections",
      displayName: "Sections",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.SeatMapSectionDto as ObjectType & { name: "SeatMapSectionDto" }) },
      },
      role: "value",
    },
    annotations: {
      name: "annotations",
      displayName: "Annotations",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.SeatMapAnnotationDto as ObjectType & { name: "SeatMapAnnotationDto" }) },
      },
      role: "value",
    },
  },
}
export const SeatMapSeatDto = domain.types.SeatMapSeatDto = {
  name: "SeatMapSeatDto" as const,
  displayName: "Seat Map Seat Dto",
  type: "object",
  props: {
    seatNumber: {
      name: "seatNumber",
      displayName: "Seat Number",
      type: "string",
      role: "value",
    },
    x: {
      name: "x",
      displayName: "X",
      type: "number",
      role: "value",
    },
    y: {
      name: "y",
      displayName: "Y",
      type: "number",
      role: "value",
    },
    amountOfSeats: {
      name: "amountOfSeats",
      displayName: "Amount Of Seats",
      type: "number",
      role: "value",
    },
    width: {
      name: "width",
      displayName: "Width",
      type: "number",
      role: "value",
    },
    height: {
      name: "height",
      displayName: "Height",
      type: "number",
      role: "value",
    },
    fontScale: {
      name: "fontScale",
      displayName: "Font Scale",
      type: "number",
      role: "value",
    },
  },
}
export const SeatMapSection = domain.types.SeatMapSection = {
  name: "SeatMapSection" as const,
  displayName: "Seat Map Section",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    seatMapId: {
      name: "seatMapId",
      displayName: "Seat Map Id",
      type: "number",
      role: "value",
    },
    seatMap: {
      name: "seatMap",
      displayName: "Seat Map",
      type: "object",
      get typeDef() { return (domain.types.SeatMap as ObjectType & { name: "SeatMap" }) },
      role: "value",
    },
    name: {
      name: "name",
      displayName: "Name",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Name is required.",
      }
    },
    color: {
      name: "color",
      displayName: "Color",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Color is required.",
        maxLength: val => !val || val.length <= 7 || "Color may not be more than 7 characters.",
      }
    },
    type: {
      name: "type",
      displayName: "Type",
      type: "enum",
      get typeDef() { return SectionTypes },
      role: "value",
      defaultValue: 0,
    },
    isHidden: {
      name: "isHidden",
      displayName: "Is Hidden",
      type: "boolean",
      role: "value",
    },
    sjSectionId: {
      name: "sjSectionId",
      displayName: "Sj Section Id",
      type: "string",
      role: "value",
    },
  },
}
export const SeatMapSectionDto = domain.types.SeatMapSectionDto = {
  name: "SeatMapSectionDto" as const,
  displayName: "Seat Map Section Dto",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    name: {
      name: "name",
      displayName: "Name",
      type: "string",
      role: "value",
    },
    color: {
      name: "color",
      displayName: "Color",
      type: "string",
      role: "value",
    },
    type: {
      name: "type",
      displayName: "Type",
      type: "enum",
      get typeDef() { return SectionTypes },
      role: "value",
    },
    isHidden: {
      name: "isHidden",
      displayName: "Is Hidden",
      type: "boolean",
      role: "value",
    },
    seats: {
      name: "seats",
      displayName: "Seats",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.SeatMapSeatDto as ObjectType & { name: "SeatMapSeatDto" }) },
      },
      role: "value",
    },
    prices: {
      name: "prices",
      displayName: "Prices",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.EventPriceDto as ObjectType & { name: "EventPriceDto" }) },
      },
      role: "value",
    },
    sjSectionId: {
      name: "sjSectionId",
      displayName: "Sj Section Id",
      type: "string",
      role: "value",
    },
  },
}
export const SeriesCoveredDate = domain.types.SeriesCoveredDate = {
  name: "SeriesCoveredDate" as const,
  displayName: "Series Covered Date",
  type: "object",
  props: {
    eventDateId: {
      name: "eventDateId",
      displayName: "Event Date Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    startLocal: {
      name: "startLocal",
      displayName: "Start Local",
      type: "date",
      dateKind: "datetime",
      noOffset: true,
      role: "value",
      dontSerialize: true,
    },
    endLocal: {
      name: "endLocal",
      displayName: "End Local",
      type: "date",
      dateKind: "datetime",
      noOffset: true,
      role: "value",
      dontSerialize: true,
    },
    timezoneAbbreviation: {
      name: "timezoneAbbreviation",
      displayName: "Timezone Abbreviation",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const TakenSeatPurchaserName = domain.types.TakenSeatPurchaserName = {
  name: "TakenSeatPurchaserName" as const,
  displayName: "Taken Seat Purchaser Name",
  type: "object",
  props: {
    seatNumber: {
      name: "seatNumber",
      displayName: "Seat Number",
      type: "string",
      role: "value",
    },
    purchaserName: {
      name: "purchaserName",
      displayName: "Purchaser Name",
      type: "string",
      role: "value",
    },
  },
}
export const Tenant = domain.types.Tenant = {
  name: "Tenant" as const,
  displayName: "Tenant",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    tenantId: {
      name: "tenantId",
      displayName: "Tenant Id",
      type: "number",
      role: "value",
    },
    name: {
      name: "name",
      displayName: "Name",
      description: "The name of the tenant, shown throughout the application to both patrons and logged-in users.",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Name is required.",
      }
    },
    shortCode: {
      name: "shortCode",
      displayName: "Short Code",
      description: "A short code that uniquely identifies the tenant. Depending on Payment Gateway settings, this may be prepended to invoice numbers.",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Short Code is required.",
        minLength: val => !val || val.length >= 3 || "Short Code must be at least 3 characters.",
        maxLength: val => !val || val.length <= 3 || "Short Code may not be more than 3 characters.",
      }
    },
    supportEmail: {
      name: "supportEmail",
      displayName: "Support Email",
      description: "An email address that patrons may message to receive customer support.",
      type: "string",
      role: "value",
      rules: {
        email: val => !val || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<> ()\[\]\\.,;:\s@"]+)*)|(".+ "))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val.trim()) || "Support Email must be a valid email address.",
      }
    },
    supportPhone: {
      name: "supportPhone",
      displayName: "Support Phone",
      description: "A phone number that patrons may call to receive customer support.",
      type: "string",
      role: "value",
    },
    emailSenderAddress: {
      name: "emailSenderAddress",
      displayName: "Email Sender Address",
      description: "The 'From' address + domain when sending email with Mailgun. Required to send purchase confirmations and other essential communication.",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      rules: {
        email: val => !val || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<> ()\[\]\\.,;:\s@"]+)*)|(".+ "))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val.trim()) || "Email Sender Address must be a valid email address.",
      }
    },
    centralAccountingEmail: {
      name: "centralAccountingEmail",
      displayName: "Central Accounting Email",
      description: "Email address that receives notifications when fee or tax absorption is enabled on an event. Leave blank to disable notifications.",
      type: "string",
      subtype: "email",
      role: "value",
      hidden: 1 as HiddenAreas,
      rules: {
        maxLength: val => !val || val.length <= 256 || "Central Accounting Email may not be more than 256 characters.",
        email: val => !val || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<> ()\[\]\\.,;:\s@"]+)*)|(".+ "))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val.trim()) || "Central Accounting Email must be a valid email address.",
      }
    },
    mailgunApiKey: {
      name: "mailgunApiKey",
      displayName: "Mailgun Api Key",
      description: "A Mailgun API key that corresponds to the domain used in Email Sender Address. Required to send purchase confirmations and other essential communication.",
      type: "string",
      subtype: "password",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    twilioMessageServiceSid: {
      name: "twilioMessageServiceSid",
      displayName: "Twilio Message Service Sid",
      type: "string",
      subtype: "password",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    externalApiKey: {
      name: "externalApiKey",
      displayName: "External Api Key",
      description: "External API Key used by Integrations to read/write on Ticket Goat",
      type: "string",
      subtype: "password",
      role: "value",
      hidden: 3 as HiddenAreas,
    },
    allowedIpAddresses: {
      name: "allowedIpAddresses",
      displayName: "Allowed Ip Addresses",
      description: "IP Addresses that are allowed to connect to the API.",
      type: "string",
      role: "value",
      hidden: 3 as HiddenAreas,
    },
    marketingEnabled: {
      name: "marketingEnabled",
      displayName: "Marketing Enabled",
      description: "If enabled, patrons will be asked during their purchase if they want to sign up for marketing communications. Note that the actual sending of marketing communications is an orthogonal process not handled by this application in any way.",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    textMessagingEnabled: {
      name: "textMessagingEnabled",
      displayName: "Text Messaging Enabled",
      description: "If enabled, tenant can send text messages to all customers who subscribed to the service",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    metaPixelsEnabled: {
      name: "metaPixelsEnabled",
      displayName: "Meta Pixels Enabled",
      description: "If enabled, Meta Pixels will be running in the front-end web pages",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    bankStatementNotificationEnabled: {
      name: "bankStatementNotificationEnabled",
      displayName: "Bank Statement Notification Enabled",
      description: "If enabled, tenant will see the Ticket Goat disclaimer message during checkout",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: true,
    },
    metaPixelAppId: {
      name: "metaPixelAppId",
      displayName: "Meta Pixel App Id",
      description: "A Meta Pixel Application ID is unique key for each tenant and can be managed over Meta Pixel admin console",
      type: "string",
      subtype: "password",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    googleAnalyticsMeasurementId: {
      name: "googleAnalyticsMeasurementId",
      displayName: "Google Analytics Measurement Id",
      description: "A Google Analytics 4 Measurement ID (e.g. G-XXXXXXXXXX). When set, GA4 tracking will be injected on the public ticketing pages for this tenant.",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    paymentGatewayId: {
      name: "paymentGatewayId",
      displayName: "Payment Gateway Id",
      type: "number",
      role: "value",
      rules: {
        required: val => val != null || "Payment Gateway Id is required.",
      }
    },
    paymentGateway: {
      name: "paymentGateway",
      displayName: "Payment Gateway",
      type: "object",
      get typeDef() { return (domain.types.PaymentGateway as ObjectType & { name: "PaymentGateway" }) },
      role: "value",
    },
    refundableFeePercentage: {
      name: "refundableFeePercentage",
      displayName: "Refundable Fee Percentage",
      description: "The cost of the purchase protection option, as a percentage of the total of the Ticket Prices for the purchase.",
      type: "number",
      role: "value",
      hidden: 1 as HiddenAreas,
      rules: {
        min: val => val == null || val >= 0 || "Refundable Fee Percentage must be at least 0.",
        max: val => val == null || val <= 100 || "Refundable Fee Percentage may not be more than 100.",
      }
    },
    convenienceFeePercentage: {
      name: "convenienceFeePercentage",
      displayName: "Convenience Fee Percentage",
      description: "A percent surcharge applied to the grand total (before taxes) of all purchases.",
      type: "number",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: 3,
      rules: {
        min: val => val == null || val >= 0 || "Convenience Fee Percentage must be at least 0.",
        max: val => val == null || val <= 100 || "Convenience Fee Percentage may not be more than 100.",
      }
    },
    serviceFeeAmount: {
      name: "serviceFeeAmount",
      displayName: "Service Fee Amount",
      description: "A surcharge, in dollars, applied for each ticket in a purchase.",
      type: "number",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: 1,
      rules: {
        min: val => val == null || val >= 0 || "Service Fee Amount must be at least 0.",
      }
    },
    agentServiceFeeAmount: {
      name: "agentServiceFeeAmount",
      displayName: "Agent Service Fee Amount",
      description: "A surcharge applies on agents, in dollars, applied for each ticket in a purchase.",
      type: "number",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: 1,
      rules: {
        min: val => val == null || val >= 0 || "Agent Service Fee Amount must be at least 0.",
      }
    },
    isAllowOverrideServiceFee: {
      name: "isAllowOverrideServiceFee",
      displayName: "Is Allow Override Service Fee",
      description: "if enabled, tenant or admin can override the service fee (regular/agent) when editing ticket type entity.",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: false,
    },
    showImageOnListView: {
      name: "showImageOnListView",
      displayName: "Show Image On List View",
      description: "This will allow adding images to the event list view.",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: true,
    },
    isIntegrationsEnabled: {
      name: "isIntegrationsEnabled",
      displayName: "Is Integrations Enabled",
      description: "This flag indicates whether this Tenant is allowed to use their API key to integrate with Ticket Goat.",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: false,
    },
    isCustomMoreOptionsButtonEnabled: {
      name: "isCustomMoreOptionsButtonEnabled",
      displayName: "Is Custom More Options Button Enabled",
      description: "Allows Tenant to alter the text on the Sell Tickets and More Options button label",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: false,
    },
    showStatusColumnOnListView: {
      name: "showStatusColumnOnListView",
      displayName: "Show Status Column On List View",
      description: "Shows the status column when on the list view.",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: true,
    },
    isAllowFreeEvent: {
      name: "isAllowFreeEvent",
      displayName: "Is Allow Free Event",
      description: "This will allow tenant to create non-paid events. Provide an extra step while creating an event.",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: false,
    },
    showRemainingSeats: {
      name: "showRemainingSeats",
      displayName: "Show Remaining Seats",
      description: "Enabling this will show remaining seats for all active events.",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: true,
    },
    showEventDurationInPublic: {
      name: "showEventDurationInPublic",
      displayName: "Show Event Duration In Public",
      description: "Enabling this will show the 'Duration' column in the public purchase event list page.",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: true,
    },
    showDynamicReports: {
      name: "showDynamicReports",
      displayName: "Show Dynamic Reports",
      description: "Enabling this will show dynamic agent and admin reports.",
      type: "boolean",
      role: "value",
      defaultValue: false,
    },
    showStaticReports: {
      name: "showStaticReports",
      displayName: "Show Static Reports",
      description: "Enabling this will show static agent and admin reports.",
      type: "boolean",
      role: "value",
      defaultValue: false,
    },
    dietaryRestrictionNotificationEmailAddress: {
      name: "dietaryRestrictionNotificationEmailAddress",
      displayName: "Dietary Restriction Notification Email Address",
      description: "The email to notify when a purchase with dietary restrictions is made.",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      rules: {
        email: val => !val || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<> ()\[\]\\.,;:\s@"]+)*)|(".+ "))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val.trim()) || "Dietary Restriction Notification Email Address must be a valid email address.",
      }
    },
    colorPrimary: {
      name: "colorPrimary",
      displayName: "Color Primary",
      type: "string",
      subtype: "color",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Color Primary is required.",
        pattern: val => !val || /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(val) || "Color Primary does not match expected format.",
      }
    },
    colorSecondary: {
      name: "colorSecondary",
      displayName: "Color Secondary",
      type: "string",
      subtype: "color",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Color Secondary is required.",
        pattern: val => !val || /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(val) || "Color Secondary does not match expected format.",
      }
    },
    colorAccent: {
      name: "colorAccent",
      displayName: "Color Accent",
      type: "string",
      subtype: "color",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Color Accent is required.",
        pattern: val => !val || /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(val) || "Color Accent does not match expected format.",
      }
    },
    enableGridView: {
      name: "enableGridView",
      displayName: "Enable Grid View",
      description: "Enable Grid View for Event Dates List.",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    showPrivateBookingOptions: {
      name: "showPrivateBookingOptions",
      displayName: "Show Private Booking Options",
      description: "Show Private Booking Options.",
      type: "boolean",
      role: "value",
      defaultValue: true,
    },
    isWaiversEnabled: {
      name: "isWaiversEnabled",
      displayName: "Is Waivers Enabled",
      description: "If enabled, waivers will be visible in the admin application for events and event dates.",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: false,
    },
    isRefundEnabled: {
      name: "isRefundEnabled",
      displayName: "Allow Refunds",
      description: "If enabled, authorized users within the tenant can process refunds.",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: true,
    },
    isEventSeriesEnabled: {
      name: "isEventSeriesEnabled",
      displayName: "Enable Event Series",
      description: "If enabled, authorized users within the tenant can configure and sell event series.",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
      defaultValue: false,
    },
    ticketDeliveryReleaseHoursBeforeEvent: {
      name: "ticketDeliveryReleaseHoursBeforeEvent",
      displayName: "Ticket Delivery Release (Hours Before Event)",
      description: "How many hours before an event starts that a public purchase's ticket PDFs become available to download or print. For example, 24 releases tickets one day before the event. Receipts still send immediately. Leave blank to deliver tickets as soon as the purchase completes. Purchases made after the release time has already passed are delivered immediately. Staff can always download tickets on a customer's behalf.",
      type: "number",
      role: "value",
      hidden: 3 as HiddenAreas,
      rules: {
        min: val => val == null || val >= 0 || "Ticket Delivery Release (Hours Before Event) must be at least 0.",
      }
    },
    ticketReleaseEmailId: {
      name: "ticketReleaseEmailId",
      displayName: "Ticket Release Email Template",
      description: "Emailed to the customer when a purchase held by the ticket delivery delay becomes downloadable. Applies to every event unless the event selects its own release template. Leave blank to send no release notification.",
      type: "number",
      role: "value",
      hidden: 3 as HiddenAreas,
    },
    ticketReleaseEmail: {
      name: "ticketReleaseEmail",
      displayName: "Ticket Release Email",
      type: "object",
      get typeDef() { return (domain.types.EmailTemplate as ObjectType & { name: "EmailTemplate" }) },
      role: "value",
      hidden: 3 as HiddenAreas,
    },
    allowAbsorbConvenienceFee: {
      name: "allowAbsorbConvenienceFee",
      displayName: "Allow Absorb Convenience Fee",
      description: "If enabled, authorized users within the tenant can absorb the convenience fee, removing it from the customer's total.",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    allowAbsorbTax: {
      name: "allowAbsorbTax",
      displayName: "Allow Absorb Tax",
      description: "If enabled, authorized users within the tenant can absorb the tax, removing it from the customer's total.",
      type: "boolean",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    accountExecutive: {
      name: "accountExecutive",
      displayName: "Account Executive",
      description: "Account Executive",
      type: "string",
      role: "value",
    },
    eventDateListDefaultTab: {
      name: "eventDateListDefaultTab",
      displayName: "Public Site Default Tab for Event Dates List",
      description: "Default Tab for Event Dates List. Valid values: list, calendar, grid",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      rules: {
        required: val => (val != null && val !== '') || "Public Site Default Tab for Event Dates List is required.",
        pattern: val => !val || /^list$|^calendar$|^grid$/.test(val) || "Public Site Default Tab for Event Dates List does not match expected format.",
      }
    },
    agentEventDateListDefaultTab: {
      name: "agentEventDateListDefaultTab",
      displayName: "Agent Default Tab for Event Dates List",
      description: "Default Tab for the agent Event Dates List. Valid values: list, calendar, grid",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      rules: {
        required: val => (val != null && val !== '') || "Agent Default Tab for Event Dates List is required.",
        pattern: val => !val || /^list$|^calendar$|^grid$/.test(val) || "Agent Default Tab for Event Dates List does not match expected format.",
      }
    },
    eventDateListDefaultCalendarView: {
      name: "eventDateListDefaultCalendarView",
      displayName: "Event Date List Default Calendar View",
      description: "Default Calendar View Type for Event Dates List. Valid values: month, day",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      rules: {
        pattern: val => !val || /^month$|^day$/.test(val) || "Event Date List Default Calendar View does not match expected format.",
      }
    },
    hosts: {
      name: "hosts",
      displayName: "Hosts",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.TenantHost as ObjectType & { name: "TenantHost" }) },
      },
      role: "value",
    },
    faviconUrl: {
      name: "faviconUrl",
      displayName: "Favicon",
      type: "string",
      subtype: "url-image",
      role: "value",
      dontSerialize: true,
    },
    fullLogoUrl: {
      name: "fullLogoUrl",
      displayName: "Full Logo",
      type: "string",
      subtype: "url-image",
      role: "value",
      dontSerialize: true,
    },
    squareLogoUrl: {
      name: "squareLogoUrl",
      displayName: "Square Logo",
      type: "string",
      subtype: "url-image",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    seatMapMethod: {
      name: "seatMapMethod",
      displayName: "Seat Map Method",
      type: "enum",
      get typeDef() { return SeatMapMethodEnum },
      role: "value",
      hidden: 2 as HiddenAreas,
    },
    tenantCommissions: {
      name: "tenantCommissions",
      displayName: "Tenant Commissions",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.TenantCommission as ObjectType & { name: "TenantCommission" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const TenantCommission = domain.types.TenantCommission = {
  name: "TenantCommission" as const,
  displayName: "Tenant Commission",
  type: "object",
  props: {
    tenantId: {
      name: "tenantId",
      displayName: "Tenant Id",
      type: "number",
      role: "value",
    },
    tenant: {
      name: "tenant",
      displayName: "Tenant",
      type: "object",
      get typeDef() { return (domain.types.Tenant as ObjectType & { name: "Tenant" }) },
      role: "value",
    },
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    commissionType: {
      name: "commissionType",
      displayName: "Commission Type",
      type: "enum",
      get typeDef() { return CommissionType },
      role: "value",
    },
    commissionFee: {
      name: "commissionFee",
      displayName: "Commission Fee",
      type: "number",
      role: "value",
    },
    isActive: {
      name: "isActive",
      displayName: "Is Active",
      type: "boolean",
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const TenantHost = domain.types.TenantHost = {
  name: "TenantHost" as const,
  displayName: "Tenant Host",
  type: "object",
  props: {
    tenantHostId: {
      name: "tenantHostId",
      displayName: "Tenant Host Id",
      type: "number",
      role: "value",
    },
    tenantId: {
      name: "tenantId",
      displayName: "Tenant Id",
      type: "number",
      role: "value",
    },
    tenant: {
      name: "tenant",
      displayName: "Tenant",
      type: "object",
      get typeDef() { return (domain.types.Tenant as ObjectType & { name: "Tenant" }) },
      role: "value",
    },
    host: {
      name: "host",
      displayName: "Host",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Host is required.",
      }
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const TenantMembership = domain.types.TenantMembership = {
  name: "TenantMembership" as const,
  displayName: "Tenant Membership",
  type: "object",
  props: {
    tenantMembershipId: {
      name: "tenantMembershipId",
      displayName: "Tenant Membership Id",
      type: "number",
      role: "value",
    },
    tenantId: {
      name: "tenantId",
      displayName: "Tenant Id",
      type: "number",
      role: "value",
    },
    tenant: {
      name: "tenant",
      displayName: "Tenant",
      type: "object",
      get typeDef() { return (domain.types.Tenant as ObjectType & { name: "Tenant" }) },
      role: "value",
    },
    userId: {
      name: "userId",
      displayName: "User Id",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "User Id is required.",
      }
    },
    user: {
      name: "user",
      displayName: "User",
      type: "object",
      get typeDef() { return (domain.types.AppUser as ObjectType & { name: "AppUser" }) },
      role: "value",
    },
    isEmailSubscribed: {
      name: "isEmailSubscribed",
      displayName: "Is Email Subscribed",
      type: "boolean",
      role: "value",
      defaultValue: true,
    },
    isPhoneSubscribed: {
      name: "isPhoneSubscribed",
      displayName: "Is Phone Subscribed",
      type: "boolean",
      role: "value",
      defaultValue: true,
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const TextMessagingTemplate = domain.types.TextMessagingTemplate = {
  name: "TextMessagingTemplate" as const,
  displayName: "Text Messaging Template",
  get displayProp() { return this.props.description }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    description: {
      name: "description",
      displayName: "Description",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Description is required.",
      }
    },
    bodyText: {
      name: "bodyText",
      displayName: "Body Text",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      rules: {
        required: val => (val != null && val !== '') || "Body Text is required.",
      }
    },
    type: {
      name: "type",
      displayName: "Type",
      type: "enum",
      get typeDef() { return TextMessagingType },
      role: "value",
      rules: {
        required: val => val != null || "Type is required.",
      }
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const TicketCategory = domain.types.TicketCategory = {
  name: "TicketCategory" as const,
  displayName: "Ticket Category",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    name: {
      name: "name",
      displayName: "Name",
      description: "Category name used to organize ticket types for reporting.",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Name is required.",
        maxLength: val => !val || val.length <= 100 || "Name may not be more than 100 characters.",
      }
    },
    description: {
      name: "description",
      displayName: "Description",
      description: "Optional description of this category's purpose.",
      type: "string",
      role: "value",
    },
    isArchived: {
      name: "isArchived",
      displayName: "Is Archived",
      type: "boolean",
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const TicketInput = domain.types.TicketInput = {
  name: "TicketInput" as const,
  displayName: "Ticket Input",
  type: "object",
  props: {
    eventPriceId: {
      name: "eventPriceId",
      displayName: "Event Price Id",
      type: "number",
      role: "value",
    },
    quantity: {
      name: "quantity",
      displayName: "Quantity",
      type: "number",
      role: "value",
    },
  },
}
export const TicketNameUpdate = domain.types.TicketNameUpdate = {
  name: "TicketNameUpdate" as const,
  displayName: "Ticket Name Update",
  type: "object",
  props: {
    ticketId: {
      name: "ticketId",
      displayName: "Ticket Id",
      type: "number",
      role: "value",
    },
    assignedFirstName: {
      name: "assignedFirstName",
      displayName: "Assigned First Name",
      type: "string",
      role: "value",
    },
    assignedLastName: {
      name: "assignedLastName",
      displayName: "Assigned Last Name",
      type: "string",
      role: "value",
    },
  },
}
export const TicketPriceBreakdown = domain.types.TicketPriceBreakdown = {
  name: "TicketPriceBreakdown" as const,
  displayName: "Ticket Price Breakdown",
  type: "object",
  props: {
    eventPriceId: {
      name: "eventPriceId",
      displayName: "Event Price Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    fees: {
      name: "fees",
      displayName: "Fees",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    convenienceFee: {
      name: "convenienceFee",
      displayName: "Convenience Fee",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    salesTax: {
      name: "salesTax",
      displayName: "Sales Tax",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    totalSingle: {
      name: "totalSingle",
      displayName: "Total Single",
      type: "number",
      role: "value",
    },
    total: {
      name: "total",
      displayName: "Total",
      type: "number",
      role: "value",
    },
  },
}
export const TicketPurchase = domain.types.TicketPurchase = {
  name: "TicketPurchase" as const,
  displayName: "Ticket Purchase",
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    publicId: {
      name: "publicId",
      displayName: "Public Id",
      type: "string",
      role: "value",
    },
    customerEmail: {
      name: "customerEmail",
      displayName: "Customer Email",
      type: "string",
      role: "value",
    },
    confirmationCode: {
      name: "confirmationCode",
      displayName: "Confirmation Code",
      type: "string",
      role: "value",
    },
    marketingCommunicationOptOut: {
      name: "marketingCommunicationOptOut",
      displayName: "Marketing Communication Opt Out",
      type: "boolean",
      role: "value",
    },
    hasSpecialNeeds: {
      name: "hasSpecialNeeds",
      displayName: "Has Special Needs",
      type: "boolean",
      role: "value",
    },
    customerFirstName: {
      name: "customerFirstName",
      displayName: "Customer First Name",
      type: "string",
      role: "value",
    },
    customerLastName: {
      name: "customerLastName",
      displayName: "Customer Last Name",
      type: "string",
      role: "value",
    },
    type: {
      name: "type",
      displayName: "Type",
      type: "enum",
      get typeDef() { return PurchaseType },
      role: "value",
    },
    absorbProcessingFee: {
      name: "absorbProcessingFee",
      displayName: "Absorb Processing Fee",
      type: "boolean",
      role: "value",
    },
    status: {
      name: "status",
      displayName: "Status",
      type: "enum",
      get typeDef() { return PurchaseStatus },
      role: "value",
    },
    failedCompletionAttempts: {
      name: "failedCompletionAttempts",
      displayName: "Failed Completion Attempts",
      type: "number",
      role: "value",
    },
    transactionDate: {
      name: "transactionDate",
      displayName: "Transaction Date",
      type: "date",
      dateKind: "datetime",
      role: "value",
    },
    customerPhoneNumber: {
      name: "customerPhoneNumber",
      displayName: "Customer Phone Number",
      type: "string",
      role: "value",
    },
    customerPhoneNumberNormalized: {
      name: "customerPhoneNumberNormalized",
      displayName: "Customer Phone Number Normalized",
      type: "string",
      role: "value",
    },
    printAtHome: {
      name: "printAtHome",
      displayName: "Print At Home",
      type: "boolean",
      role: "value",
    },
    willCall: {
      name: "willCall",
      displayName: "Will Call",
      type: "boolean",
      role: "value",
    },
    mailingAddressStreet: {
      name: "mailingAddressStreet",
      displayName: "Mailing Address Street",
      type: "string",
      role: "value",
    },
    mailingAddressCity: {
      name: "mailingAddressCity",
      displayName: "Mailing Address City",
      type: "string",
      role: "value",
    },
    mailingAddressState: {
      name: "mailingAddressState",
      displayName: "Mailing Address State",
      type: "string",
      role: "value",
    },
    mailingAddressZip: {
      name: "mailingAddressZip",
      displayName: "Mailing Address Zip",
      type: "string",
      role: "value",
    },
    mailingAddressCountry: {
      name: "mailingAddressCountry",
      displayName: "Mailing Address Country",
      type: "string",
      role: "value",
    },
    roomNumber: {
      name: "roomNumber",
      displayName: "Room Number",
      type: "string",
      role: "value",
    },
    waiveTicketFees: {
      name: "waiveTicketFees",
      displayName: "Waive Ticket Fees",
      type: "boolean",
      role: "value",
    },
    pendingExchangeTickets: {
      name: "pendingExchangeTickets",
      displayName: "Pending Exchange Tickets",
      type: "string",
      role: "value",
    },
    pendingExchangeAddons: {
      name: "pendingExchangeAddons",
      displayName: "Pending Exchange Addons",
      type: "string",
      role: "value",
    },
    refunded: {
      name: "refunded",
      displayName: "Refunded",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    refundComment: {
      name: "refundComment",
      displayName: "Refund Comment",
      type: "string",
      role: "value",
    },
    refundable: {
      name: "refundable",
      displayName: "Refundable",
      type: "enum",
      get typeDef() { return RefundableState },
      role: "value",
    },
    refundPolicy: {
      name: "refundPolicy",
      displayName: "Refund Policy",
      type: "string",
      role: "value",
    },
    refundableFeePercentage: {
      name: "refundableFeePercentage",
      displayName: "Refundable Fee Percentage",
      type: "number",
      role: "value",
    },
    refundableFee: {
      name: "refundableFee",
      displayName: "Refundable Fee",
      type: "number",
      role: "value",
    },
    absorbedTax: {
      name: "absorbedTax",
      displayName: "Absorbed Tax",
      type: "boolean",
      role: "value",
    },
    refundsRefundableFee: {
      name: "refundsRefundableFee",
      displayName: "Refunds Refundable Fee",
      type: "boolean",
      role: "value",
    },
    convenienceFeePercentage: {
      name: "convenienceFeePercentage",
      displayName: "Convenience Fee Percentage",
      type: "number",
      role: "value",
    },
    salesTaxPercentage: {
      name: "salesTaxPercentage",
      displayName: "Sales Tax Percentage",
      type: "number",
      role: "value",
    },
    serviceFeeAmount: {
      name: "serviceFeeAmount",
      displayName: "Service Fee Amount",
      type: "number",
      role: "value",
    },
    failureMessage: {
      name: "failureMessage",
      displayName: "Failure Message",
      type: "string",
      role: "value",
    },
    isPublicPurchase: {
      name: "isPublicPurchase",
      displayName: "Is Public Purchase",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    originalTicketPurchaseId: {
      name: "originalTicketPurchaseId",
      displayName: "Original Ticket Purchase Id",
      type: "number",
      role: "value",
    },
    originalTicketPurchase: {
      name: "originalTicketPurchase",
      displayName: "Original Ticket Purchase",
      type: "object",
      get typeDef() { return (domain.types.TicketPurchase as ObjectType & { name: "TicketPurchase" }) },
      role: "value",
    },
    newTicketPurchases: {
      name: "newTicketPurchases",
      displayName: "New Ticket Purchases",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.TicketPurchase as ObjectType & { name: "TicketPurchase" }) },
      },
      role: "value",
    },
    eventId: {
      name: "eventId",
      displayName: "Event Id",
      type: "number",
      role: "value",
    },
    event: {
      name: "event",
      displayName: "Event",
      type: "object",
      get typeDef() { return (domain.types.Event as ObjectType & { name: "Event" }) },
      role: "value",
    },
    eventDateId: {
      name: "eventDateId",
      displayName: "Event Date Id",
      type: "number",
      role: "value",
    },
    eventDate: {
      name: "eventDate",
      displayName: "Event Date",
      type: "object",
      get typeDef() { return (domain.types.EventDate as ObjectType & { name: "EventDate" }) },
      role: "value",
    },
    eventSeriesId: {
      name: "eventSeriesId",
      displayName: "Event Series Id",
      type: "number",
      role: "value",
    },
    eventSeries: {
      name: "eventSeries",
      displayName: "Event Series",
      type: "object",
      get typeDef() { return (domain.types.EventSeries as ObjectType & { name: "EventSeries" }) },
      role: "value",
    },
    passTypeId: {
      name: "passTypeId",
      displayName: "Pass Type Id",
      type: "number",
      role: "value",
    },
    passType: {
      name: "passType",
      displayName: "Pass Type",
      type: "object",
      get typeDef() { return (domain.types.PassType as ObjectType & { name: "PassType" }) },
      role: "value",
    },
    eventStartDateTime: {
      name: "eventStartDateTime",
      displayName: "Event Start Date Time",
      type: "date",
      dateKind: "datetime",
      role: "value",
    },
    creditCardSummary: {
      name: "creditCardSummary",
      displayName: "Credit Card Summary",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    attendeeNames: {
      name: "attendeeNames",
      displayName: "Attendee Names",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    firstCoveredEventDate: {
      name: "firstCoveredEventDate",
      displayName: "First Covered Event Date",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
    lastCoveredEventDate: {
      name: "lastCoveredEventDate",
      displayName: "Last Covered Event Date",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
    refundOverrideLogs: {
      name: "refundOverrideLogs",
      displayName: "Refund Override Logs",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.RefundOverrideLog as ObjectType & { name: "RefundOverrideLog" }) },
      },
      role: "value",
    },
    consigneeCommissionId: {
      name: "consigneeCommissionId",
      displayName: "Consignee Commission Id",
      type: "number",
      role: "value",
    },
    consigneeCommission: {
      name: "consigneeCommission",
      displayName: "Consignee Commission",
      type: "object",
      get typeDef() { return (domain.types.ConsigneeCommission as ObjectType & { name: "ConsigneeCommission" }) },
      role: "value",
    },
    tenantCommissionId: {
      name: "tenantCommissionId",
      displayName: "Tenant Commission Id",
      type: "number",
      role: "value",
    },
    tenantCommission: {
      name: "tenantCommission",
      displayName: "Tenant Commission",
      type: "object",
      get typeDef() { return (domain.types.TenantCommission as ObjectType & { name: "TenantCommission" }) },
      role: "value",
    },
    isAllowTextMessaging: {
      name: "isAllowTextMessaging",
      displayName: "Is Allow Text Messaging",
      type: "boolean",
      role: "value",
      defaultValue: false,
    },
    externalReferenceId: {
      name: "externalReferenceId",
      displayName: "External Reference Id",
      type: "string",
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const TicketPurchaseAddon = domain.types.TicketPurchaseAddon = {
  name: "TicketPurchaseAddon" as const,
  displayName: "Ticket Purchase Addon",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    addonId: {
      name: "addonId",
      displayName: "Addon Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    addonItemConfigurationId: {
      name: "addonItemConfigurationId",
      displayName: "Addon Item Configuration Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    name: {
      name: "name",
      displayName: "Name",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    marketingDescription: {
      name: "marketingDescription",
      displayName: "Marketing Description",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    price: {
      name: "price",
      displayName: "Price",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    convenienceFee: {
      name: "convenienceFee",
      displayName: "Convenience Fee",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    refundedPrice: {
      name: "refundedPrice",
      displayName: "Refunded Price",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    totalValue: {
      name: "totalValue",
      displayName: "Total Value",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    salesTax: {
      name: "salesTax",
      displayName: "Sales Tax",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    isPerTicket: {
      name: "isPerTicket",
      displayName: "Is Per Ticket",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    status: {
      name: "status",
      displayName: "Status",
      type: "enum",
      get typeDef() { return AddonStatus },
      role: "value",
      dontSerialize: true,
    },
    isPrintable: {
      name: "isPrintable",
      displayName: "Is Printable",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    relatedPurchase: {
      name: "relatedPurchase",
      displayName: "Related Purchase",
      type: "object",
      get typeDef() { return (domain.types.TicketPurchaseRelatedPurchase as ObjectType & { name: "TicketPurchaseRelatedPurchase" }) },
      role: "value",
      dontSerialize: true,
    },
  },
}
export const TicketPurchaseDietaryRestriction = domain.types.TicketPurchaseDietaryRestriction = {
  name: "TicketPurchaseDietaryRestriction" as const,
  displayName: "Ticket Purchase Dietary Restriction",
  type: "object",
  props: {
    allergen: {
      name: "allergen",
      displayName: "Allergen",
      type: "string",
      role: "value",
    },
    guestQuantity: {
      name: "guestQuantity",
      displayName: "Guest Quantity",
      type: "number",
      role: "value",
    },
    comment: {
      name: "comment",
      displayName: "Comment",
      type: "string",
      role: "value",
    },
    canComment: {
      name: "canComment",
      displayName: "Can Comment",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const TicketPurchaseDiscount = domain.types.TicketPurchaseDiscount = {
  name: "TicketPurchaseDiscount" as const,
  displayName: "Ticket Purchase Discount",
  type: "object",
  props: {
    discountId: {
      name: "discountId",
      displayName: "Discount Id",
      type: "number",
      role: "value",
    },
    description: {
      name: "description",
      displayName: "Description",
      type: "string",
      role: "value",
    },
    amount: {
      name: "amount",
      displayName: "Amount",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    error: {
      name: "error",
      displayName: "Error",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const TicketPurchasePayment = domain.types.TicketPurchasePayment = {
  name: "TicketPurchasePayment" as const,
  displayName: "Ticket Purchase Payment",
  type: "object",
  props: {
    paymentId: {
      name: "paymentId",
      displayName: "Payment Id",
      type: "number",
      role: "value",
    },
    paymentTypeName: {
      name: "paymentTypeName",
      displayName: "Payment Type Name",
      type: "string",
      role: "value",
    },
    amount: {
      name: "amount",
      displayName: "Amount",
      type: "number",
      role: "value",
    },
    description: {
      name: "description",
      displayName: "Description",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    paymentKind: {
      name: "paymentKind",
      displayName: "Payment Kind",
      type: "enum",
      get typeDef() { return PaymentKind },
      role: "value",
      dontSerialize: true,
    },
    requiresCcInput: {
      name: "requiresCcInput",
      displayName: "Requires Cc Input",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    canChangeAmount: {
      name: "canChangeAmount",
      displayName: "Can Change Amount",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    canRemove: {
      name: "canRemove",
      displayName: "Can Remove",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    isRefund: {
      name: "isRefund",
      displayName: "Is Refund",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    allowsNegativeSum: {
      name: "allowsNegativeSum",
      displayName: "Allows Negative Sum",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    allowsPositiveSum: {
      name: "allowsPositiveSum",
      displayName: "Allows Positive Sum",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    maxRefundableAmount: {
      name: "maxRefundableAmount",
      displayName: "Max Refundable Amount",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    relatedPurchases: {
      name: "relatedPurchases",
      displayName: "Related Purchases",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.TicketPurchaseRelatedPurchase as ObjectType & { name: "TicketPurchaseRelatedPurchase" }) },
      },
      role: "value",
      dontSerialize: true,
    },
  },
}
export const TicketPurchaseRelatedPurchase = domain.types.TicketPurchaseRelatedPurchase = {
  name: "TicketPurchaseRelatedPurchase" as const,
  displayName: "Ticket Purchase Related Purchase",
  get displayProp() { return this.props.description }, 
  type: "object",
  props: {
    publicId: {
      name: "publicId",
      displayName: "Public Id",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    description: {
      name: "description",
      displayName: "Description",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    ticketIds: {
      name: "ticketIds",
      displayName: "Ticket Ids",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "number",
      },
      role: "value",
      dontSerialize: true,
    },
    addonIds: {
      name: "addonIds",
      displayName: "Addon Ids",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "number",
      },
      role: "value",
      dontSerialize: true,
    },
  },
}
export const TicketPurchaseSeat = domain.types.TicketPurchaseSeat = {
  name: "TicketPurchaseSeat" as const,
  displayName: "Ticket Purchase Seat",
  type: "object",
  props: {
    seatId: {
      name: "seatId",
      displayName: "Seat Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    ticketId: {
      name: "ticketId",
      displayName: "Ticket Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    seatNumber: {
      name: "seatNumber",
      displayName: "Seat Number",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    seatLabel: {
      name: "seatLabel",
      displayName: "Seat Label",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    scanDate: {
      name: "scanDate",
      displayName: "Scan Date",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
    assignedFirstName: {
      name: "assignedFirstName",
      displayName: "Assigned First Name",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    assignedLastName: {
      name: "assignedLastName",
      displayName: "Assigned Last Name",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const TicketPurchaseTicket = domain.types.TicketPurchaseTicket = {
  name: "TicketPurchaseTicket" as const,
  displayName: "Ticket Purchase Ticket",
  type: "object",
  props: {
    ticketId: {
      name: "ticketId",
      displayName: "Ticket Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    eventPriceId: {
      name: "eventPriceId",
      displayName: "Event Price Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    passTypeId: {
      name: "passTypeId",
      displayName: "Pass Type Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    passInstanceId: {
      name: "passInstanceId",
      displayName: "Pass Instance Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    eventDateId: {
      name: "eventDateId",
      displayName: "Event Date Id",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    seatNumber: {
      name: "seatNumber",
      displayName: "Seat Number",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    seatSectionName: {
      name: "seatSectionName",
      displayName: "Seat Section Name",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    seatLabel: {
      name: "seatLabel",
      displayName: "Seat Label",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    displayName: {
      name: "displayName",
      displayName: "Display Name",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    description: {
      name: "description",
      displayName: "Description",
      type: "string",
      role: "value",
      dontSerialize: true,
    },
    price: {
      name: "price",
      displayName: "Price",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    fees: {
      name: "fees",
      displayName: "Fees",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    convenienceFee: {
      name: "convenienceFee",
      displayName: "Convenience Fee",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    salesTax: {
      name: "salesTax",
      displayName: "Sales Tax",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    refundableFee: {
      name: "refundableFee",
      displayName: "Refundable Fee",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    discountTotal: {
      name: "discountTotal",
      displayName: "Discount Total",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    subtotalWithFees: {
      name: "subtotalWithFees",
      displayName: "Subtotal With Fees",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    addons: {
      name: "addons",
      displayName: "Addons",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    totalValue: {
      name: "totalValue",
      displayName: "Total Value",
      type: "number",
      role: "value",
      dontSerialize: true,
    },
    status: {
      name: "status",
      displayName: "Status",
      type: "enum",
      get typeDef() { return TicketStatus },
      role: "value",
      dontSerialize: true,
    },
    isScanned: {
      name: "isScanned",
      displayName: "Is Scanned",
      type: "boolean",
      role: "value",
      dontSerialize: true,
    },
    relatedPurchase: {
      name: "relatedPurchase",
      displayName: "Related Purchase",
      type: "object",
      get typeDef() { return (domain.types.TicketPurchaseRelatedPurchase as ObjectType & { name: "TicketPurchaseRelatedPurchase" }) },
      role: "value",
      dontSerialize: true,
    },
    isReservedIndividualSeat: {
      name: "isReservedIndividualSeat",
      displayName: "Is Reserved Individual Seat",
      type: "boolean",
      role: "value",
    },
    ticketSeats: {
      name: "ticketSeats",
      displayName: "Ticket Seats",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.TicketPurchaseSeat as ObjectType & { name: "TicketPurchaseSeat" }) },
      },
      role: "value",
      dontSerialize: true,
    },
    assignedFirstName: {
      name: "assignedFirstName",
      displayName: "Assigned First Name",
      type: "string",
      role: "value",
    },
    assignedLastName: {
      name: "assignedLastName",
      displayName: "Assigned Last Name",
      type: "string",
      role: "value",
    },
  },
}
export const TicketTemplate = domain.types.TicketTemplate = {
  name: "TicketTemplate" as const,
  displayName: "Ticket Template",
  get displayProp() { return this.props.description }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    description: {
      name: "description",
      displayName: "Description",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Description is required.",
      }
    },
    htmlContent: {
      name: "htmlContent",
      displayName: "Html Content",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    pageHeightInches: {
      name: "pageHeightInches",
      displayName: "Page Height (inches)",
      type: "number",
      role: "value",
    },
    pageWidthInches: {
      name: "pageWidthInches",
      displayName: "Page Width (inches)",
      type: "number",
      role: "value",
    },
    companyName: {
      name: "companyName",
      displayName: "Company Name",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Company Name is required.",
      }
    },
    events: {
      name: "events",
      displayName: "Events",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.Event as ObjectType & { name: "Event" }) },
      },
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const TicketType = domain.types.TicketType = {
  name: "TicketType" as const,
  displayName: "Ticket Type",
  get displayProp() { return this.props.name }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    ticketCategoryId: {
      name: "ticketCategoryId",
      displayName: "Ticket Category Id",
      type: "number",
      role: "value",
      rules: {
        required: val => val != null || "Ticket Category Id is required.",
      }
    },
    ticketCategory: {
      name: "ticketCategory",
      displayName: "Ticket Category",
      description: "The category this ticket type belongs to.",
      type: "object",
      get typeDef() { return (domain.types.TicketCategory as ObjectType & { name: "TicketCategory" }) },
      role: "value",
    },
    name: {
      name: "name",
      displayName: "Name",
      description: "Reusable ticket type name shown to customers.",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Name is required.",
        maxLength: val => !val || val.length <= 100 || "Name may not be more than 100 characters.",
      }
    },
    details: {
      name: "details",
      displayName: "Details",
      description: "Optional subtitle or additional details for this ticket type.",
      type: "string",
      role: "value",
      rules: {
        maxLength: val => !val || val.length <= 100 || "Details may not be more than 100 characters.",
      }
    },
    order: {
      name: "order",
      displayName: "Order",
      description: "Controls display ordering. Lower numbers appear first.",
      type: "number",
      role: "value",
    },
    isArchived: {
      name: "isArchived",
      displayName: "Is Archived",
      type: "boolean",
      role: "value",
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const Venue = domain.types.Venue = {
  name: "Venue" as const,
  displayName: "Venue",
  get displayProp() { return this.props.displayName }, 
  type: "object",
  props: {
    id: {
      name: "id",
      displayName: "Id",
      type: "number",
      role: "value",
    },
    displayName: {
      name: "displayName",
      displayName: "Display Name",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Display Name is required.",
      }
    },
    boardingLabel: {
      name: "boardingLabel",
      displayName: "Early arrival label",
      description: "The type of early arrival that can occur for events in this venue. This verbiage will be displayed next to event descriptions and is available in ticket/email templates.",
      type: "enum",
      get typeDef() { return BoardingLabel },
      role: "value",
    },
    salesTaxPercentage: {
      name: "salesTaxPercentage",
      displayName: "Sales Tax Percentage",
      description: "The tax percentage applied to the grand total of the purchase.",
      type: "number",
      role: "value",
      rules: {
        required: val => val != null || "Sales Tax Percentage is required.",
        min: val => val == null || val >= 0 || "Sales Tax Percentage must be at least 0.",
        max: val => val == null || val <= 100 || "Sales Tax Percentage may not be more than 100.",
      }
    },
    disclaimer: {
      name: "disclaimer",
      displayName: "Disclaimer",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    events: {
      name: "events",
      displayName: "Events",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.Event as ObjectType & { name: "Event" }) },
      },
      role: "value",
    },
    seatMaps: {
      name: "seatMaps",
      displayName: "Seat Maps",
      type: "collection",
      itemType: {
        name: "$collectionItem",
        displayName: "",
        role: "value",
        type: "object",
        get typeDef() { return (domain.types.SeatMap as ObjectType & { name: "SeatMap" }) },
      },
      role: "value",
      hidden: 1 as HiddenAreas,
    },
    address: {
      name: "address",
      displayName: "Address",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Address is required.",
      }
    },
    state: {
      name: "state",
      displayName: "State",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "State is required.",
      }
    },
    zip: {
      name: "zip",
      displayName: "Zip",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Zip is required.",
      }
    },
    country: {
      name: "country",
      displayName: "Country",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Country is required.",
      }
    },
    timeZone: {
      name: "timeZone",
      displayName: "Time Zone",
      description: "The time zone of the venue. Choose from the available US time zones.",
      type: "string",
      role: "value",
      rules: {
        required: val => (val != null && val !== '') || "Time Zone is required.",
      }
    },
    creationUserName: {
      name: "creationUserName",
      displayName: "Created By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    creationDate: {
      name: "creationDate",
      displayName: "Created On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeUserName: {
      name: "lastChangeUserName",
      displayName: "Modified By",
      type: "string",
      role: "value",
      hidden: 1 as HiddenAreas,
      dontSerialize: true,
    },
    lastChangeDate: {
      name: "lastChangeDate",
      displayName: "Modified On",
      type: "date",
      dateKind: "datetime",
      role: "value",
      dontSerialize: true,
    },
  },
}
export const PublicBannerAlertService = domain.services.PublicBannerAlertService = {
  name: "PublicBannerAlertService",
  displayName: "Public Banner Alert Service",
  type: "service",
  controllerRoute: "PublicBannerAlertService",
  methods: {
    getActiveBannerAlerts: {
      name: "getActiveBannerAlerts",
      displayName: "Get Active Banner Alerts",
      transportType: "item",
      httpMethod: "POST",
      params: {
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "collection",
        itemType: {
          name: "$collectionItem",
          displayName: "",
          role: "value",
          type: "object",
          get typeDef() { return (domain.types.PublicBannerAlertDto as ObjectType & { name: "PublicBannerAlertDto" }) },
        },
        role: "value",
      },
    },
  },
}
export const PublicPurchaseService = domain.services.PublicPurchaseService = {
  name: "PublicPurchaseService",
  displayName: "Public Purchase Service",
  type: "service",
  controllerRoute: "PublicPurchaseService",
  methods: {
    initiatePurchase: {
      name: "initiatePurchase",
      displayName: "Initiate Purchase",
      transportType: "item",
      httpMethod: "POST",
      params: {
        eventDateId: {
          name: "eventDateId",
          displayName: "Event Date Id",
          type: "number",
          role: "value",
        },
        accessCode: {
          name: "accessCode",
          displayName: "Access Code",
          type: "string",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "model",
        get typeDef() { return (domain.types.TicketPurchaseDto as ModelType & { name: "TicketPurchaseDto" }) },
        role: "value",
      },
    },
    initiateSeriesPurchase: {
      name: "initiateSeriesPurchase",
      displayName: "Initiate Series Purchase",
      transportType: "item",
      httpMethod: "POST",
      params: {
        eventSeriesId: {
          name: "eventSeriesId",
          displayName: "Event Series Id",
          type: "number",
          role: "value",
        },
        accessCode: {
          name: "accessCode",
          displayName: "Access Code",
          type: "string",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "model",
        get typeDef() { return (domain.types.TicketPurchaseDto as ModelType & { name: "TicketPurchaseDto" }) },
        role: "value",
      },
    },
    getSeriesById: {
      name: "getSeriesById",
      displayName: "Get Series By Id",
      transportType: "item",
      httpMethod: "POST",
      params: {
        eventSeriesId: {
          name: "eventSeriesId",
          displayName: "Event Series Id",
          type: "number",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "object",
        get typeDef() { return (domain.types.PublicSeriesDto as ObjectType & { name: "PublicSeriesDto" }) },
        role: "value",
      },
    },
    setSeriesPassTypeQuantity: {
      name: "setSeriesPassTypeQuantity",
      displayName: "Set Series Pass Type Quantity",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
        passTypeId: {
          name: "passTypeId",
          displayName: "Pass Type Id",
          type: "number",
          role: "value",
        },
        quantity: {
          name: "quantity",
          displayName: "Quantity",
          type: "number",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "model",
        get typeDef() { return (domain.types.TicketPurchaseDto as ModelType & { name: "TicketPurchaseDto" }) },
        role: "value",
      },
    },
    completeSeriesPayment: {
      name: "completeSeriesPayment",
      displayName: "Complete Series Payment",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
        cardDetails: {
          name: "cardDetails",
          displayName: "Card Details",
          type: "object",
          get typeDef() { return (domain.types.CreditCardDetails as ObjectType & { name: "CreditCardDetails" }) },
          role: "value",
          rules: {
            required: val => val != null || "Card Details is required.",
          }
        },
        captchaToken: {
          name: "captchaToken",
          displayName: "Captcha Token",
          type: "string",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "string",
        role: "value",
      },
    },
    getSeating: {
      name: "getSeating",
      displayName: "Get Seating",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "object",
        get typeDef() { return (domain.types.EventDateSeatingInfo as ObjectType & { name: "EventDateSeatingInfo" }) },
        role: "value",
      },
    },
    setTicketQuantity: {
      name: "setTicketQuantity",
      displayName: "Set Ticket Quantity",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
        eventPriceId: {
          name: "eventPriceId",
          displayName: "Event Price Id",
          type: "number",
          role: "value",
        },
        quantity: {
          name: "quantity",
          displayName: "Quantity",
          type: "number",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "model",
        get typeDef() { return (domain.types.TicketPurchaseDto as ModelType & { name: "TicketPurchaseDto" }) },
        role: "value",
      },
    },
    addTicket: {
      name: "addTicket",
      displayName: "Add Ticket",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
        eventPriceId: {
          name: "eventPriceId",
          displayName: "Event Price Id",
          type: "number",
          role: "value",
        },
        seat: {
          name: "seat",
          displayName: "Seat",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Seat is required.",
          }
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "model",
        get typeDef() { return (domain.types.TicketPurchaseDto as ModelType & { name: "TicketPurchaseDto" }) },
        role: "value",
      },
    },
    addMultipleTickets: {
      name: "addMultipleTickets",
      displayName: "Add Multiple Tickets",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
        tickets: {
          name: "tickets",
          displayName: "Tickets",
          type: "collection",
          itemType: {
            name: "$collectionItem",
            displayName: "",
            role: "value",
            type: "object",
            get typeDef() { return (domain.types.TicketInput as ObjectType & { name: "TicketInput" }) },
          },
          role: "value",
          rules: {
            required: val => val != null || "Tickets is required.",
          }
        },
        seat: {
          name: "seat",
          displayName: "Seat",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Seat is required.",
          }
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "model",
        get typeDef() { return (domain.types.TicketPurchaseDto as ModelType & { name: "TicketPurchaseDto" }) },
        role: "value",
      },
    },
    removeMultipleTickets: {
      name: "removeMultipleTickets",
      displayName: "Remove Multiple Tickets",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
        ticketIdList: {
          name: "ticketIdList",
          displayName: "Ticket Id List",
          type: "collection",
          itemType: {
            name: "$collectionItem",
            displayName: "",
            role: "value",
            type: "number",
          },
          role: "value",
          rules: {
            required: val => val != null || "Ticket Id List is required.",
          }
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "model",
        get typeDef() { return (domain.types.TicketPurchaseDto as ModelType & { name: "TicketPurchaseDto" }) },
        role: "value",
      },
    },
    removeTicket: {
      name: "removeTicket",
      displayName: "Remove Ticket",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
        ticketId: {
          name: "ticketId",
          displayName: "Ticket Id",
          type: "number",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "model",
        get typeDef() { return (domain.types.TicketPurchaseDto as ModelType & { name: "TicketPurchaseDto" }) },
        role: "value",
      },
    },
    updateTicketNames: {
      name: "updateTicketNames",
      displayName: "Update Ticket Names",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
        ticketNames: {
          name: "ticketNames",
          displayName: "Ticket Names",
          type: "collection",
          itemType: {
            name: "$collectionItem",
            displayName: "",
            role: "value",
            type: "object",
            get typeDef() { return (domain.types.TicketNameUpdate as ObjectType & { name: "TicketNameUpdate" }) },
          },
          role: "value",
          rules: {
            required: val => val != null || "Ticket Names is required.",
          }
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "model",
        get typeDef() { return (domain.types.TicketPurchaseDto as ModelType & { name: "TicketPurchaseDto" }) },
        role: "value",
      },
    },
    setAddonQuantity: {
      name: "setAddonQuantity",
      displayName: "Set Addon Quantity",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
        addonConfigId: {
          name: "addonConfigId",
          displayName: "Addon Config Id",
          type: "number",
          role: "value",
        },
        quantity: {
          name: "quantity",
          displayName: "Quantity",
          type: "number",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "model",
        get typeDef() { return (domain.types.TicketPurchaseDto as ModelType & { name: "TicketPurchaseDto" }) },
        role: "value",
      },
    },
    setDietaryRestriction: {
      name: "setDietaryRestriction",
      displayName: "Set Dietary Restriction",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
        allergen: {
          name: "allergen",
          displayName: "Allergen",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Allergen is required.",
          }
        },
        quantity: {
          name: "quantity",
          displayName: "Quantity",
          type: "number",
          role: "value",
        },
        comment: {
          name: "comment",
          displayName: "Comment",
          type: "string",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "model",
        get typeDef() { return (domain.types.TicketPurchaseDto as ModelType & { name: "TicketPurchaseDto" }) },
        role: "value",
      },
    },
    removeDiscount: {
      name: "removeDiscount",
      displayName: "Remove Discount",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
        discountId: {
          name: "discountId",
          displayName: "Discount Id",
          type: "number",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "model",
        get typeDef() { return (domain.types.TicketPurchaseDto as ModelType & { name: "TicketPurchaseDto" }) },
        role: "value",
      },
    },
    applyDiscountCode: {
      name: "applyDiscountCode",
      displayName: "Apply Discount Code",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
        discountCode: {
          name: "discountCode",
          displayName: "Discount Code",
          type: "string",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "model",
        get typeDef() { return (domain.types.TicketPurchaseDto as ModelType & { name: "TicketPurchaseDto" }) },
        role: "value",
      },
    },
    completePublicCardPayment: {
      name: "completePublicCardPayment",
      displayName: "Complete Public Card Payment",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
        cardDetails: {
          name: "cardDetails",
          displayName: "Card Details",
          type: "object",
          get typeDef() { return (domain.types.CreditCardDetails as ObjectType & { name: "CreditCardDetails" }) },
          role: "value",
          rules: {
            required: val => val != null || "Card Details is required.",
          }
        },
        captchaToken: {
          name: "captchaToken",
          displayName: "Captcha Token",
          type: "string",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "string",
        role: "value",
      },
    },
    getPostalCodeInfo: {
      name: "getPostalCodeInfo",
      displayName: "Get Postal Code Info",
      transportType: "item",
      httpMethod: "POST",
      params: {
        postalCode: {
          name: "postalCode",
          displayName: "Postal Code",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Postal Code is required.",
          }
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "object",
        get typeDef() { return (domain.types.PostalCodeInfo as ObjectType & { name: "PostalCodeInfo" }) },
        role: "value",
      },
    },
    markTicketPurchaseHoneyPotSpam: {
      name: "markTicketPurchaseHoneyPotSpam",
      displayName: "Mark Ticket Purchase Honey Pot Spam",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "void",
        role: "value",
      },
    },
    abandonPurchase: {
      name: "abandonPurchase",
      displayName: "Abandon Purchase",
      transportType: "item",
      httpMethod: "POST",
      params: {
        publicId: {
          name: "publicId",
          displayName: "Public Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Public Id is required.",
          }
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "void",
        role: "value",
      },
    },
  },
}
export const PublicSystemAlertService = domain.services.PublicSystemAlertService = {
  name: "PublicSystemAlertService",
  displayName: "Public System Alert Service",
  type: "service",
  controllerRoute: "PublicSystemAlertService",
  methods: {
    getActiveAlert: {
      name: "getActiveAlert",
      displayName: "Get Active Alert",
      transportType: "item",
      httpMethod: "POST",
      params: {
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "object",
        get typeDef() { return (domain.types.PublicSystemAlertDto as ObjectType & { name: "PublicSystemAlertDto" }) },
        role: "value",
      },
    },
  },
}
export const SignInService = domain.services.SignInService = {
  name: "SignInService",
  displayName: "Sign In Service",
  type: "service",
  controllerRoute: "SignInService",
  methods: {
    signIn: {
      name: "signIn",
      displayName: "Sign In",
      transportType: "item",
      httpMethod: "POST",
      params: {
        userName: {
          name: "userName",
          displayName: "User Name",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "User Name is required.",
          }
        },
        password: {
          name: "password",
          displayName: "Password",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Password is required.",
          }
        },
        rememberMe: {
          name: "rememberMe",
          displayName: "Remember Me",
          type: "boolean",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "void",
        role: "value",
      },
    },
    requestPasswordReset: {
      name: "requestPasswordReset",
      displayName: "Request Password Reset",
      transportType: "item",
      httpMethod: "POST",
      params: {
        userName: {
          name: "userName",
          displayName: "User Name",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "User Name is required.",
          }
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "void",
        role: "value",
      },
    },
    resetPassword: {
      name: "resetPassword",
      displayName: "Reset Password",
      transportType: "item",
      httpMethod: "POST",
      params: {
        userName: {
          name: "userName",
          displayName: "User Name",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "User Name is required.",
          }
        },
        code: {
          name: "code",
          displayName: "Code",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Code is required.",
          }
        },
        newPassword: {
          name: "newPassword",
          displayName: "New Password",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "New Password is required.",
          }
        },
        confirmNewPassword: {
          name: "confirmNewPassword",
          displayName: "Confirm New Password",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Confirm New Password is required.",
          }
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "void",
        role: "value",
      },
    },
    setupAccount: {
      name: "setupAccount",
      displayName: "Setup Account",
      transportType: "item",
      httpMethod: "POST",
      params: {
        userName: {
          name: "userName",
          displayName: "User Name",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "User Name is required.",
          }
        },
        code: {
          name: "code",
          displayName: "Code",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Code is required.",
          }
        },
        newPassword: {
          name: "newPassword",
          displayName: "New Password",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "New Password is required.",
          }
        },
        confirmNewPassword: {
          name: "confirmNewPassword",
          displayName: "Confirm New Password",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Confirm New Password is required.",
          }
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "void",
        role: "value",
      },
    },
    confirmEmail: {
      name: "confirmEmail",
      displayName: "Confirm Email",
      transportType: "item",
      httpMethod: "POST",
      params: {
        userId: {
          name: "userId",
          displayName: "User Id",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "User Id is required.",
          }
        },
        code: {
          name: "code",
          displayName: "Code",
          type: "string",
          role: "value",
          rules: {
            required: val => (val != null && val !== '') || "Code is required.",
          }
        },
        newEmail: {
          name: "newEmail",
          displayName: "New Email",
          type: "string",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "void",
        role: "value",
      },
    },
  },
}
export const VmtService = domain.services.VmtService = {
  name: "VmtService",
  displayName: "Vmt Service",
  type: "service",
  controllerRoute: "VmtService",
  methods: {
    getVmtEventId: {
      name: "getVmtEventId",
      displayName: "Get Vmt Event Id",
      transportType: "item",
      httpMethod: "POST",
      params: {
        ticketingSeatMapId: {
          name: "ticketingSeatMapId",
          displayName: "Ticketing Seat Map Id",
          type: "number",
          role: "value",
        },
        eventDateId: {
          name: "eventDateId",
          displayName: "Event Date Id",
          type: "number",
          role: "value",
        },
        eventId: {
          name: "eventId",
          displayName: "Event Id",
          type: "number",
          role: "value",
        },
        mode: {
          name: "mode",
          displayName: "Mode",
          type: "string",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "string",
        role: "value",
      },
    },
    getVmtToken: {
      name: "getVmtToken",
      displayName: "Get Vmt Token",
      transportType: "item",
      httpMethod: "POST",
      params: {
        vmtEventId: {
          name: "vmtEventId",
          displayName: "Vmt Event Id",
          type: "string",
          role: "value",
        },
        mode: {
          name: "mode",
          displayName: "Mode",
          type: "string",
          role: "value",
        },
      },
      return: {
        name: "$return",
        displayName: "Result",
        type: "string",
        role: "value",
      },
    },
  },
}

interface AppDomain extends Domain {
  enums: {
    AddonItemType: typeof AddonItemType
    AddonStatus: typeof AddonStatus
    AlertSeverity: typeof AlertSeverity
    BoardingLabel: typeof BoardingLabel
    CommissionType: typeof CommissionType
    DiscountType: typeof DiscountType
    EmailType: typeof EmailType
    EventSeriesStatus: typeof EventSeriesStatus
    PassCategory: typeof PassCategory
    PaymentKind: typeof PaymentKind
    PurchaseStatus: typeof PurchaseStatus
    PurchaseType: typeof PurchaseType
    RefundableState: typeof RefundableState
    SeatMapAnnotationShape: typeof SeatMapAnnotationShape
    SeatMapMethodEnum: typeof SeatMapMethodEnum
    SectionTypes: typeof SectionTypes
    TextMessagingType: typeof TextMessagingType
    TicketStatus: typeof TicketStatus
  }
  types: {
    AddonItemConfiguration: typeof AddonItemConfiguration
    AddonItemDefinition: typeof AddonItemDefinition
    AppRole: typeof AppRole
    AppUser: typeof AppUser
    AppUserAllTenantRole: typeof AppUserAllTenantRole
    AppUserRole: typeof AppUserRole
    AvailableSeatsDetails: typeof AvailableSeatsDetails
    Consignee: typeof Consignee
    ConsigneeCommission: typeof ConsigneeCommission
    ConsigneeDiscountDefinition: typeof ConsigneeDiscountDefinition
    ConsigneeRep: typeof ConsigneeRep
    CreditCardDetails: typeof CreditCardDetails
    DiscountDefinition: typeof DiscountDefinition
    DiscountDefinitionConfiguration: typeof DiscountDefinitionConfiguration
    EmailTemplate: typeof EmailTemplate
    Event: typeof Event
    EventAddonDto: typeof EventAddonDto
    EventAddonItemDefinition: typeof EventAddonItemDefinition
    EventDate: typeof EventDate
    EventDateDiscountDefinition: typeof EventDateDiscountDefinition
    EventDateDto: typeof EventDateDto
    EventDatePriceConfig: typeof EventDatePriceConfig
    EventDateSeatingInfo: typeof EventDateSeatingInfo
    EventDateSeatingRestrictionInfo: typeof EventDateSeatingRestrictionInfo
    EventDateSeatRestriction: typeof EventDateSeatRestriction
    EventDiscountDefinition: typeof EventDiscountDefinition
    EventDto: typeof EventDto
    EventEmailTemplate: typeof EventEmailTemplate
    EventImage: typeof EventImage
    EventImageDto: typeof EventImageDto
    EventPrice: typeof EventPrice
    EventPriceDto: typeof EventPriceDto
    EventPriceRevenueDistribution: typeof EventPriceRevenueDistribution
    EventSection: typeof EventSection
    EventSectionPrice: typeof EventSectionPrice
    EventSeries: typeof EventSeries
    EventSuggestedEvent: typeof EventSuggestedEvent
    EventType: typeof EventType
    EventTypeDto: typeof EventTypeDto
    PassType: typeof PassType
    PassTypeDate: typeof PassTypeDate
    PaymentGateway: typeof PaymentGateway
    PostalCodeInfo: typeof PostalCodeInfo
    PublicBannerAlertDto: typeof PublicBannerAlertDto
    PublicSeriesDto: typeof PublicSeriesDto
    PublicSeriesPassTypeDto: typeof PublicSeriesPassTypeDto
    PublicSystemAlertDto: typeof PublicSystemAlertDto
    RefundOverrideLog: typeof RefundOverrideLog
    RevenueCategory: typeof RevenueCategory
    SeatMap: typeof SeatMap
    SeatMapAnnotationDto: typeof SeatMapAnnotationDto
    SeatMapDto: typeof SeatMapDto
    SeatMapSeatDto: typeof SeatMapSeatDto
    SeatMapSection: typeof SeatMapSection
    SeatMapSectionDto: typeof SeatMapSectionDto
    SeriesCoveredDate: typeof SeriesCoveredDate
    TakenSeatPurchaserName: typeof TakenSeatPurchaserName
    Tenant: typeof Tenant
    TenantCommission: typeof TenantCommission
    TenantHost: typeof TenantHost
    TenantMembership: typeof TenantMembership
    TextMessagingTemplate: typeof TextMessagingTemplate
    TicketCategory: typeof TicketCategory
    TicketInput: typeof TicketInput
    TicketNameUpdate: typeof TicketNameUpdate
    TicketPriceBreakdown: typeof TicketPriceBreakdown
    TicketPurchase: typeof TicketPurchase
    TicketPurchaseAddon: typeof TicketPurchaseAddon
    TicketPurchaseDietaryRestriction: typeof TicketPurchaseDietaryRestriction
    TicketPurchaseDiscount: typeof TicketPurchaseDiscount
    TicketPurchaseDto: typeof TicketPurchaseDto
    TicketPurchasePayment: typeof TicketPurchasePayment
    TicketPurchaseRelatedPurchase: typeof TicketPurchaseRelatedPurchase
    TicketPurchaseSeat: typeof TicketPurchaseSeat
    TicketPurchaseTicket: typeof TicketPurchaseTicket
    TicketTemplate: typeof TicketTemplate
    TicketType: typeof TicketType
    Venue: typeof Venue
  }
  services: {
    PublicBannerAlertService: typeof PublicBannerAlertService
    PublicPurchaseService: typeof PublicPurchaseService
    PublicSystemAlertService: typeof PublicSystemAlertService
    SignInService: typeof SignInService
    VmtService: typeof VmtService
  }
}

solidify(domain)

export default domain as unknown as AppDomain
